// import React, { useState, useEffect, useMemo, useRef } from "react";
// import { useToast } from "../context/ToastContext";
// import { useOutletContext } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import axios from "axios";
// import { API_BASE_URL } from "../utils/config";
// import MedicalCertificate from './MedicalCertificate';
// import CandidateEducation from './CandidateEducation';
// import {
//   FiCreditCard, FiShield, FiUsers,
//   FiUpload, FiCheckCircle, FiAlertTriangle, FiEye,
//   FiX, FiRefreshCw, FiBriefcase, FiPhone,
//   FiEdit, FiInbox, FiFile, FiAward, FiImage,
//   FiMapPin, FiClock, FiArrowRight
// } from "react-icons/fi";
// import "./EmployeeDashboard.css";

// const CandidatePersonalDocuments = () => {
//   const { showToast } = useToast();
//   const { personalDocs, fetchDashboardData, formatDocumentUrl, profile } = useOutletContext();
//   const docs = useMemo(() => personalDocs?.documents || personalDocs || {}, [personalDocs]);
//   const [uploading, setUploading] = useState({});
//   const [localSearch, setLocalSearch] = useState("");

//   // ✅ Helper: get best available auth header or candidateId
//   const getAuthHeaders = () => {
//     const token = localStorage.getItem("candidateToken");
//     if (token && token !== "null" && token !== "undefined") {
//       return { Authorization: `Bearer ${token}` };
//     }
//     return {}; // fallback — candidateId will be sent in body
//   };

//   const getCandidateId = () => {
//     return profile?._id || localStorage.getItem("candidateId") || null;
//   };

//   const [isBankModalOpen, setIsBankModalOpen] = useState(false);
//   const [isEmergencyModalOpen, setIsEmergencyModalOpen] = useState(false);
//   const [isPersonalModalOpen, setIsPersonalModalOpen] = useState(false);
//   const [isSaving, setIsSaving] = useState(false);

//   const [bankForm, setBankForm] = useState({ bankName: "", accountNumber: "", ifscCode: "" });
//   const [emergencyForm, setEmergencyForm] = useState({ name: "", phone: "", relationship: "" });
//   const [personalForm, setPersonalForm] = useState({
//     name: "", phone: "", address: "",
//     dob: "", gender: "", city: "", state: "", pincode: "", role: []
//   });

//   const [availableRoles, setAvailableRoles] = useState([]);
//   const [showRoleDropdown, setShowRoleDropdown] = useState(false);
//   const [roleSearch, setRoleSearch] = useState("");
//   const roleDropdownRef = useRef(null);
//   const [matchedJobs, setMatchedJobs] = useState([]);
//   const [loadingJobs, setLoadingJobs] = useState(false);

//   // Fetch available roles
//   useEffect(() => {
//     const fetchRoles = async () => {
//       try {
//         const res = await axios.get(`${API_BASE_URL}/roles/all`);
//         let rolesData = [];
//         if (Array.isArray(res.data)) rolesData = res.data;
//         else if (Array.isArray(res.data.data)) rolesData = res.data.data;
//         else if (Array.isArray(res.data.roles)) rolesData = res.data.roles;

//         const uniqueRoles = rolesData.map((r, index) => {
//           if (typeof r === 'string') return r;
//           return r.name || r.title || r.role || "";
//         }).filter(r => r !== "");

//         setAvailableRoles([...new Set(uniqueRoles)]);
//       } catch (err) {
//         console.error("Failed to fetch roles:", err);
//       }
//     };
//     fetchRoles();
//   }, []);

//   // Handle role dropdown click outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (roleDropdownRef.current && !roleDropdownRef.current.contains(event.target)) {
//         setShowRoleDropdown(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Clear role search when dropdown closes
//   useEffect(() => {
//     if (!showRoleDropdown) {
//       setRoleSearch("");
//     }
//   }, [showRoleDropdown]);

//   // Handle role toggle
//   const handleRoleToggle = (role) => {
//     setPersonalForm(prev => ({
//       ...prev,
//       role: prev.role.includes(role)
//         ? prev.role.filter(r => r !== role)
//         : [...prev.role, role]
//     }));
//   };

//   // Fetch matched jobs based on candidate's desired roles
//   useEffect(() => {
//     const fetchMatchedJobs = async () => {
//       if (!profile || !profile.role || profile.role.length === 0) {
//         setMatchedJobs([]);
//         return;
//       }

//       setLoadingJobs(true);
//       try {
//         const res = await axios.get(`${API_BASE_URL}/jobs/all`);
//         if (res.data.success) {
//           const allJobs = res.data.data || res.data.jobPosts || [];

//           // Filter jobs that match candidate's roles using partial matching
//           const candidateRoles = Array.isArray(profile.role) ? profile.role : [profile.role];
//           const matched = allJobs.filter(job => {
//             return candidateRoles.some(role => {
//               const candidateRole = role.toLowerCase().trim();
//               const jobRole = (job.role || "").toLowerCase().trim();
//               return jobRole.includes(candidateRole) || candidateRole.includes(jobRole);
//             });
//           });

//           setMatchedJobs(matched.slice(0, 5)); // Show top 5 matched jobs
//         }
//       } catch (err) {
//         console.error("Failed to fetch matched jobs:", err);
//       } finally {
//         setLoadingJobs(false);
//       }
//     };

//     fetchMatchedJobs();
//   }, [profile]);

//   // Helper function to format date for display (local time)
//   const formatDateForDisplay = (dateString) => {
//     if (!dateString) return "";
//     try {
//       const date = new Date(dateString);
//       if (isNaN(date.getTime())) return "";
//       const year = date.getFullYear();
//       const month = String(date.getMonth() + 1).padStart(2, '0');
//       const day = String(date.getDate()).padStart(2, '0');
//       return `${year}-${month}-${day}`;
//     } catch (error) {
//       return "";
//     }
//   };

//   // Validation helper functions
//   const validateAlphabetsOnly = (value) => {
//     return /^[A-Za-z\s]*$/.test(value);
//   };

//   const validateAlphabetsAndNumbersOnly = (value) => {
//     return /^[A-Za-z0-9]*$/.test(value);
//   };

//   const validateNumbersOnly = (value) => {
//     return /^\d*$/.test(value);
//   };

//   // ✅ Enhanced Indian phone number validation - exactly 10 digits starting with 6-9
//   const validatePhoneNumber = (value) => {
//     return /^[6-9]\d{9}$/.test(value);
//   };

//   // ✅ Validate phone number format with optional spaces/hyphens (for display)
//   const validatePhoneNumberWithFormatting = (value) => {
//     // Remove spaces and hyphens for validation
//     const cleanNumber = value.replace(/[\s-]/g, '');
//     return /^[6-9]\d{9}$/.test(cleanNumber);
//   };

//   const validatePincode = (value) => {
//     return /^\d{6}$/.test(value);
//   };

//   // Input handlers with validation
//   const handlePersonalInputChange = (field, value) => {
//     // For name field - only alphabets and spaces
//     if (field === 'name') {
//       if (value === '' || validateAlphabetsOnly(value)) {
//         setPersonalForm({...personalForm, [field]: value});
//       }
//       return;
//     }

//     // ✅ Enhanced phone field validation - only numbers, must start with 6-9, max 10 digits
//     if (field === 'phone') {
//       // Allow only numbers, ensure it starts with 6-9 when length > 0
//       if (value === '') {
//         setPersonalForm({...personalForm, [field]: value});
//         return;
//       }
//       // Check if value contains only numbers
//       if (/^\d*$/.test(value)) {
//         // Check if first digit (if any) is 6-9
//         if (value.length === 0 || /^[6-9]/.test(value.charAt(0))) {
//           // Limit to 10 digits
//           if (value.length <= 10) {
//             setPersonalForm({...personalForm, [field]: value});
//           }
//         }
//       }
//       return;
//     }

//     // For pincode field - only numbers, exactly 6 digits
//     if (field === 'pincode') {
//       if (value === '' || /^\d{0,6}$/.test(value)) {
//         setPersonalForm({...personalForm, [field]: value});
//       }
//       return;
//     }

//     // For address field - alphabets, numbers, spaces, and common punctuation
//     if (field === 'address') {
//       if (value === '' || /^[A-Za-z0-9\s,.-]*$/.test(value)) {
//         setPersonalForm({...personalForm, [field]: value});
//       }
//       return;
//     }

//     // For city and state fields - only alphabets and spaces
//     if (field === 'city' || field === 'state') {
//       if (value === '' || validateAlphabetsOnly(value)) {
//         setPersonalForm({...personalForm, [field]: value});
//       }
//       return;
//     }

//     // For other fields
//     setPersonalForm({...personalForm, [field]: value});
//   };

//   // Bank form input handlers
//   const handleBankInputChange = (field, value) => {
//     if (field === 'bankName') {
//       // Only alphabets and spaces for bank name
//       if (value === '' || validateAlphabetsOnly(value)) {
//         setBankForm({...bankForm, [field]: value.toUpperCase()});
//       }
//       return;
//     }

//     if (field === 'accountNumber') {
//       // Only numbers for account number
//       if (value === '' || validateNumbersOnly(value)) {
//         setBankForm({...bankForm, [field]: value});
//       }
//       return;
//     }

//     if (field === 'ifscCode') {
//       // Only alphabets and numbers for IFSC code
//       if (value === '' || validateAlphabetsAndNumbersOnly(value)) {
//         setBankForm({...bankForm, [field]: value.toUpperCase()});
//       }
//       return;
//     }
//   };

//   // Emergency form input handlers
//   const handleEmergencyInputChange = (field, value) => {
//     if (field === 'name' || field === 'relationship') {
//       // Only alphabets and spaces for name and relationship
//       if (value === '' || validateAlphabetsOnly(value)) {
//         setEmergencyForm({...emergencyForm, [field]: value.toUpperCase()});
//       }
//       return;
//     }

//     // ✅ Enhanced emergency phone validation - Indian format
//     if (field === 'phone') {
//       // Allow only numbers, ensure it starts with 6-9 when length > 0
//       if (value === '') {
//         setEmergencyForm({...emergencyForm, [field]: value});
//         return;
//       }
//       // Check if value contains only numbers
//       if (/^\d*$/.test(value)) {
//         // Check if first digit (if any) is 6-9
//         if (value.length === 0 || /^[6-9]/.test(value.charAt(0))) {
//           // Limit to 10 digits
//           if (value.length <= 10) {
//             setEmergencyForm({...emergencyForm, [field]: value});
//           }
//         }
//       }
//       return;
//     }
//   };

//   useEffect(() => {
//     if (docs.bankDetails) {
//       setBankForm({
//         bankName: docs.bankDetails.bankName || "",
//         accountNumber: docs.bankDetails.accountNumber || "",
//         ifscCode: docs.bankDetails.ifscCode || ""
//       });
//     }
//     if (docs.emergencyContact1) {
//       setEmergencyForm({
//         name: docs.emergencyContact1.name || "",
//         phone: docs.emergencyContact1.phone || "",
//         relationship: docs.emergencyContact1.relationship || ""
//       });
//     }
//     if (profile) {
//       // Format date for input field (YYYY-MM-DD) using local time
//       const formattedDob = formatDateForDisplay(profile.dob);

//       setPersonalForm({
//         name: profile.name || "",
//         phone: profile.phone || "",
//         address: profile.address || "",
//         dob: formattedDob,
//         gender: profile.gender || "",
//         city: profile.city || "",
//         state: profile.state || "",
//         pincode: profile.pincode || "",
//         role: profile.role || []
//       });
//     }
//   }, [docs, profile]);

//   const handleFileUpload = async (event, type) => {
//     const file = event.target.files[0];
//     if (!file) return;
//     setUploading({ ...uploading, [type]: true });
//     const formData = new FormData();
//     formData.append("document", file);
//     formData.append("type", type);
//     const candidateId = getCandidateId();
//     if (candidateId) formData.append("candidateId", candidateId);
//     try {
//       await axios.post(`${API_BASE_URL}/candidate/documents/upload`, formData, {
//         headers: { ...getAuthHeaders(), 'Content-Type': 'multipart/form-data' }
//       });
//       fetchDashboardData();
//     } catch (err) {
//       console.error(`Upload error for ${type}:`, err);
//       showToast("Failed to upload document. Please make sure you are logged in.", "error");
//     } finally {
//       setUploading({ ...uploading, [type]: false });
//     }
//   };

//   const handleSaveBankDetails = async (e) => {
//     if (e) e.preventDefault();

//     // Bank Name validation - only alphabets and spaces
//     if (!bankForm.bankName || bankForm.bankName.trim().length < 3) {
//       return showToast("Bank name must be at least 3 characters", "warning");
//     }
//     if (!validateAlphabetsOnly(bankForm.bankName)) {
//       return showToast("Bank name should contain only alphabets and spaces", "warning");
//     }

//     // Account Number validation - only numbers, 9-18 digits
//     if (!bankForm.accountNumber || !/^\d{9,18}$/.test(bankForm.accountNumber)) {
//       return showToast("Account number must be 9-18 digits only", "warning");
//     }

//     // IFSC Code validation - only alphabets and numbers
//     if (!bankForm.ifscCode || !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(bankForm.ifscCode.toUpperCase())) {
//       return showToast("Invalid IFSC code format (e.g., HDFC0001234) - only alphabets and numbers", "warning");
//     }

//     setIsSaving(true);
//     try {
//       await axios.post(`${API_BASE_URL}/candidate/save-bank-details`,
//         { bankDetails: bankForm, candidateId: getCandidateId() },
//         { headers: getAuthHeaders() }
//       );
//       showToast("Bank details saved successfully", "success");
//       fetchDashboardData();
//       setIsBankModalOpen(false);
//     } catch (err) {
//       console.error(err);
//       showToast(err.response?.data?.message || "Failed to save bank details", "error");
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   const handleSaveEmergencyContact = async (e) => {
//     if (e) e.preventDefault();

//     // Name validation - only alphabets and spaces
//     if (!emergencyForm.name || emergencyForm.name.trim().length < 2) {
//       return showToast("Contact name must be at least 2 characters", "warning");
//     }
//     if (!validateAlphabetsOnly(emergencyForm.name)) {
//       return showToast("Contact name should contain only alphabets and spaces", "warning");
//     }

//     // ✅ Phone validation - exactly 10 digits starting with 6, 7, 8, or 9
//     if (!emergencyForm.phone || !validatePhoneNumber(emergencyForm.phone)) {
//       return showToast("Phone number must be exactly 10 digits starting with 6, 7, 8, or 9", "warning");
//     }

//     // Relationship validation - only alphabets and spaces
//     if (!emergencyForm.relationship || emergencyForm.relationship.trim().length < 2) {
//       return showToast("Relationship must be at least 2 characters", "warning");
//     }
//     if (!validateAlphabetsOnly(emergencyForm.relationship)) {
//       return showToast("Relationship should contain only alphabets and spaces", "warning");
//     }

//     setIsSaving(true);
//     try {
//       await axios.post(`${API_BASE_URL}/candidate/save-emergency-contact`,
//         { contactNumber: 1, contact: emergencyForm, candidateId: getCandidateId() },
//         { headers: getAuthHeaders() }
//       );
//       showToast("Emergency contact saved successfully", "success");
//       fetchDashboardData();
//       setIsEmergencyModalOpen(false);
//     } catch (err) {
//       console.error(err);
//       showToast(err.response?.data?.message || "Failed to save contact", "error");
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   const handleSavePersonalDetails = async (e) => {
//     if (e) e.preventDefault();

//     // Validate Name - only alphabets and spaces
//     if (!personalForm.name || personalForm.name.trim().length < 2) {
//       return showToast("Full name must be at least 2 characters", "warning");
//     }
//     if (!validateAlphabetsOnly(personalForm.name)) {
//       return showToast("Full name should contain only alphabets and spaces", "warning");
//     }

//     // ✅ Phone validation - exactly 10 digits starting with 6, 7, 8, or 9
//     if (!personalForm.phone || !validatePhoneNumber(personalForm.phone)) {
//       return showToast("Phone number must be exactly 10 digits starting with 6, 7, 8, or 9", "warning");
//     }

//     // Validate Address - allow alphabets, numbers, spaces, and common punctuation
//     if (!personalForm.address || personalForm.address.trim().length < 5) {
//       return showToast("Address must be at least 5 characters", "warning");
//     }

//     // Validate City - only alphabets and spaces
//     if (!personalForm.city || personalForm.city.trim().length < 2) {
//       return showToast("City must be at least 2 characters", "warning");
//     }
//     if (!validateAlphabetsOnly(personalForm.city)) {
//       return showToast("City should contain only alphabets and spaces", "warning");
//     }

//     // Validate State - only alphabets and spaces
//     if (!personalForm.state || personalForm.state.trim().length < 2) {
//       return showToast("State must be at least 2 characters", "warning");
//     }
//     if (!validateAlphabetsOnly(personalForm.state)) {
//       return showToast("State should contain only alphabets and spaces", "warning");
//     }

//     // Validate Pincode - exactly 6 digits
//     if (!personalForm.pincode || !validatePincode(personalForm.pincode)) {
//       return showToast("Pincode must be exactly 6 digits", "warning");
//     }

//     setIsSaving(true);
//     try {
//       // Send payload directly - date input already returns YYYY-MM-DD format
//       const payload = { ...personalForm, candidateId: getCandidateId() };

//       // Only include dob if it has a value
//       if (!personalForm.dob) {
//         delete payload.dob;
//       }

//       console.log("Sending payload:", payload); // Debug log

//       await axios.put(`${API_BASE_URL}/candidate/profile`, payload, { headers: getAuthHeaders() });
//       showToast("Personal details updated successfully", "success");
//       fetchDashboardData();
//       setIsPersonalModalOpen(false);
//     } catch (err) {
//       console.error("Error updating profile:", err);
//       showToast(err.response?.data?.message || "Failed to update profile", "error");
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   const docCategories = [
//     { title: "Aadhar / National ID", type: "aadharCard", icon: FiCreditCard, desc: "National Identity" },
//     { title: "PAN Card", type: "panCard", icon: FiCreditCard, desc: "Tax Identity" },
//     { title: "10th Certificate", type: "tenthCertificate", icon: FiFile, desc: "Educational Record" },
//     { title: "12th Certificate", type: "twelfthCertificate", icon: FiFile, desc: "Educational Record" },
//     { title: "Graduation Degree", type: "graduationCertificate", icon: FiAward, desc: "Higher Education" },
//     { title: "Passport Photo", type: "passportPhoto", icon: FiImage, desc: "Identity Photo" }
//   ];

//   const filteredCategories = docCategories.filter(cat => 
//     cat.title.toLowerCase().includes(localSearch.toLowerCase()) ||
//     cat.desc.toLowerCase().includes(localSearch.toLowerCase())
//   );

//   return (
//     <div className="emp-dash">
//       <div className="p-4 sm:p-6 lg:p-8">
//         {/* Dashboard Header */}
//         <div className="emp-dash__header">
//           <div>
//             <h1 className="emp-dash__greeting">
//               Personal <span>Documents</span>
//             </h1>
//             <p className="emp-dash__subtitle">
//               Manage your identity and verification documents
//             </p>
//           </div>
//           <div className="emp-dash__date-pill">
//             <FiShield />
//             <span>
//               {new Date().toLocaleDateString("en-US", {
//                 weekday: "short",
//                 year: "numeric",
//                 month: "short",
//                 day: "numeric",
//               })}
//             </span>
//           </div>
//         </div>

//         {/* Personal Details Section */}
//         <div className="emp-dash__card mb-6">
//           <div className="emp-dash__card-header">
//             <div className="flex items-center gap-4">
//               <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-indigo-50 to-indigo-100 text-indigo-600 flex items-center justify-center shadow-inner border border-indigo-200/50">
//                 <FiCreditCard size={24} />
//               </div>
//               <div>
//                 <h3 className="emp-dash__card-title">Personal Profile</h3>
//                 <p className="emp-dash__card-desc">Core identity & verification data</p>
//               </div>
//             </div>
//             <button 
//               onClick={() => setIsPersonalModalOpen(true)}
//               className="flex items-center gap-2 px-5 py-2.5 bg-indigo-600 text-white rounded-xl text-xs font-bold uppercase tracking-widest hover:bg-indigo-700 transition-all shadow-lg shadow-indigo-100 active:scale-95"
//             >
//               <FiEdit size={14} /> Edit Details
//             </button>
//           </div>
//           <div className="emp-dash__card-body bg-gray-50/50">
//             <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6">
//               <div className="space-y-1">
//                 <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Full Name</p>
//                 <p className="text-sm font-bold text-gray-900 uppercase tracking-tight">{profile?.name || "Not set"}</p>
//               </div>
//               <div className="space-y-1">
//                 <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Phone Number</p>
//                 <p className="text-sm font-bold text-gray-900 tracking-tight">{profile?.phone || "Not set"}</p>
//               </div>
//               <div className="space-y-1">
//                 <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Date of Birth</p>
//                 <p className="text-sm font-bold text-gray-900 tracking-tight">
//                   {profile?.dob ? new Date(profile.dob).toLocaleDateString('en-IN', {
//                     day: '2-digit',
//                     month: 'short',
//                     year: 'numeric'
//                   }) : "Not set"}
//                 </p>
//               </div>
//               <div className="space-y-1">
//                 <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Gender</p>
//                 <p className="text-sm font-bold text-gray-900 uppercase tracking-tight">{profile?.gender || "Not set"}</p>
//               </div>
//               <div className="lg:col-span-1 space-y-1">
//                 <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Current Address</p>
//                 <p className="text-sm font-bold text-gray-900 uppercase tracking-tight leading-relaxed">
//                   {profile?.address ? `${profile.address}, ${profile.city || ""}, ${profile.state || ""} - ${profile.pincode || ""}` : "Not set"}
//                 </p>
//               </div>
//               <div className="lg:col-span-5 space-y-1">
//                 <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Desired Roles</p>
//                 <div className="flex flex-wrap gap-2 mt-1">
//                   {profile?.role && profile.role.length > 0 ? (
//                     profile.role.map((role, index) => (
//                       <span key={index} className="px-3 py-1 bg-indigo-50 text-indigo-600 rounded-lg text-xs font-bold uppercase tracking-wider border border-indigo-100">
//                         {role}
//                       </span>
//                     ))
//                   ) : (
//                     <p className="text-sm font-bold text-gray-400 italic">Not set</p>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Matched Jobs Section */}
//           {/* {matchedJobs.length > 0 && (
//             <div className="border-t border-gray-200 pt-6 mt-6">
//               <div className="flex items-center justify-between mb-4">
//                 <div>
//                   <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Matched Jobs</p>
//                   <p className="text-xs text-gray-500 mt-1">Jobs matching your desired roles</p>
//                 </div>
//               </div>
//               <div className="space-y-3">
//                 {matchedJobs.map((job) => (
//                   <div
//                     key={job._id}
//                     className="bg-white border border-gray-200 rounded-xl p-4 hover:border-indigo-300 hover:shadow-md transition-all cursor-pointer"
//                     onClick={() => window.location.href = `/applying-job/${job._id}`}
//                   >
//                     <div className="flex items-start justify-between">
//                       <div className="flex-1">
//                         <h4 className="text-sm font-bold text-gray-900 uppercase tracking-tight mb-2">{job.role}</h4>
//                         <div className="flex flex-wrap items-center gap-3 text-xs text-gray-500">
//                           <span className="flex items-center gap-1">
//                             <FiMapPin size={12} />
//                             {job.location}
//                           </span>
//                           <span className="flex items-center gap-1">
//                             <FiClock size={12} />
//                             {job.salary}
//                           </span>
//                         </div>
//                       </div>
//                       <FiArrowRight className="text-indigo-600 mt-1" size={16} />
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )} */}

//           {loadingJobs && (
//             <div className="border-t border-gray-200 pt-6 mt-6">
//               <div className="flex items-center justify-center py-4">
//                 <div className="w-6 h-6 border-2 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
//               </div>
//             </div>
//           )}
//         </div>

//       <CandidateEducation />
//       <MedicalCertificate />

//       {/* Personal Documents Section */}
//       <div className="emp-dash__card mb-6">
//         <div className="emp-dash__card-header">
//           <div className="flex items-center gap-4">
//             <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-indigo-50 to-indigo-100 text-indigo-600 flex items-center justify-center shadow-inner border border-indigo-200/50">
//               <FiShield size={24} />
//             </div>
//             <div>
//               <h3 className="emp-dash__card-title">Personal Documents</h3>
//               <p className="emp-dash__card-desc">Verification & banking vault</p>
//             </div>
//           </div>
//         </div>


//         <div className="emp-dash__card-body bg-gray-50/50">
//           <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">

//             {/* Details Sidebar - Summary Cards */}
//             <div className="lg:col-span-1 space-y-6">

//             <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-gray-100 relative group transition-all hover:shadow-md md:min-h-[280px] flex flex-col justify-between">

//               <div className="flex items-center justify-between mb-5">
//                 <div className="flex items-center gap-3">
//                   <div className="w-10 h-10 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center shadow-sm border border-blue-100/50">
//                     <FiBriefcase size={18} />
//                   </div>
//                   <div>
//                     <h3 className="text-xs font-bold text-gray-800 uppercase tracking-widest">Bank Profile</h3>
//                     <p className="text-[8px] font-bold text-gray-400 uppercase tracking-[0.2em] mt-0.5">Payroll Source</p>
//                   </div>
//                 </div>
//                 <button onClick={() => setIsBankModalOpen(true)} className="w-8 h-8 rounded-lg bg-gray-50 hover:bg-blue-600 hover:text-white text-gray-400 flex items-center justify-center transition-all shadow-sm border border-gray-100"><FiEdit size={12}/></button>
//               </div>

//               {docs.bankDetails?.accountNumber ? (
//                 <div className="space-y-3">
//                    <div className="p-4 bg-gray-50/50 rounded-xl border border-gray-100/50">
//                       <p className="text-[9px] font-bold text-gray-400 uppercase tracking-widest">Institution</p>
//                       <p className="text-xs font-bold text-gray-800 mt-1 uppercase tracking-tight">{docs.bankDetails.bankName}</p>
//                    </div>
//                    <div className="p-4 bg-gray-50/50 rounded-xl border border-gray-100/50 font-mono">
//                       <p className="text-[9px] font-bold text-gray-400 uppercase font-sans tracking-widest">A/C Number</p>
//                       <p className="text-xs font-bold text-gray-800 mt-1 tracking-widest">*******{docs.bankDetails.accountNumber.slice(-4)}</p>
//                    </div>
//                 </div>
//               ) : (
//                 <div className="p-6 bg-amber-50/50 rounded-xl border border-amber-100/50 text-center">
//                    <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-sm text-amber-500">
//                       <FiAlertTriangle size={16} />
//                    </div>
//                    <p className="text-[9px] font-bold text-amber-600 uppercase tracking-widest leading-relaxed">Config Required</p>
//                 </div>
//               )}
//             </div>

//             <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-gray-100 relative group transition-all hover:shadow-md md:min-h-[280px] flex flex-col justify-between">

//               <div className="flex items-center justify-between mb-5">
//                 <div className="flex items-center gap-3">
//                   <div className="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center shadow-sm border border-emerald-100/50">
//                     <FiUsers size={18} />
//                   </div>
//                   <div>
//                     <h3 className="text-xs font-bold text-gray-800 uppercase tracking-widest">Emergency</h3>
//                     <p className="text-[8px] font-bold text-gray-400 uppercase tracking-[0.2em] mt-0.5">Primary Liaison</p>
//                   </div>
//                 </div>
//                 <button onClick={() => setIsEmergencyModalOpen(true)} className="w-8 h-8 rounded-lg bg-gray-50 hover:bg-emerald-600 hover:text-white text-gray-400 flex items-center justify-center transition-all shadow-sm border border-gray-100"><FiEdit size={12}/></button>
//               </div>

//               {docs.emergencyContact1?.phone ? (
//                 <div className="space-y-3">
//                    <div className="p-4 bg-gray-50/50 rounded-xl border border-gray-100/50">
//                       <p className="text-[9px] font-bold text-gray-400 uppercase tracking-widest">Contact Person</p>
//                       <p className="text-xs font-bold text-gray-800 mt-1 uppercase tracking-tight">{docs.emergencyContact1.name}</p>
//                    </div>
//                    <div className="p-4 bg-gray-50/50 rounded-xl border border-gray-100/50 flex items-center gap-3 font-mono">
//                       <div className="w-7 h-7 bg-white rounded-lg flex items-center justify-center text-emerald-500 shadow-sm border border-emerald-50"><FiPhone size={10}/></div>
//                       <p className="text-xs font-bold text-gray-800 tracking-widest">{docs.emergencyContact1.phone}</p>
//                    </div>
//                 </div>
//               ) : (
//                 <div className="p-6 bg-amber-50/50 rounded-xl border border-amber-100/50 text-center">
//                    <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-sm text-amber-500">
//                       <FiAlertTriangle size={16} />
//                    </div>
//                    <p className="text-[9px] font-bold text-amber-600 uppercase tracking-widest leading-relaxed">Config Required</p>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Identity Documents Table */}
//           <div className="lg:col-span-3">
//             <div className="bg-white shadow-lg border border-gray-100 rounded-2xl md:rounded-[2.5rem] overflow-hidden">
//               <div className="flex flex-col sm:flex-row sm:items-center justify-between p-6 md:p-8 border-b border-gray-100 bg-gray-50/30 gap-4">
//                 <div className="flex items-center gap-4">
//                   <div className="w-10 h-10 md:w-12 md:h-12 rounded-2xl bg-indigo-50 text-indigo-600 flex items-center justify-center shadow-sm border border-indigo-100/50">
//                     <FiCreditCard size={20} className="md:w-6 md:h-6" />
//                   </div>
//                   <div>
//                     <h2 className="text-xs md:text-sm font-bold text-gray-800 uppercase tracking-widest">Identity Documents</h2>
//                     <p className="text-[9px] md:text-[10px] font-bold text-gray-400 uppercase tracking-[0.2em] mt-1">Verification & Security Protocol</p>
//                   </div>
//                 </div>
//                 <div className="flex items-center self-start sm:self-center gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-white border border-indigo-100 rounded-xl">
//                    <div className="w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-indigo-500 animate-pulse"></div>
//                    <span className="text-[8px] md:text-[9px] font-bold text-indigo-600 uppercase tracking-widest">Secure Storage Active</span>
//                 </div>
//               </div>

//               <div className="overflow-x-auto custom-scrollbar">
//                 <table className="min-w-[800px] w-full text-center">
//                   <thead className="text-[10px] text-gray-700 uppercase tracking-[0.2em] font-black border-b border-gray-200">
//                     <tr>
//                       <th className="py-4 md:py-5 px-4 md:px-8 text-left">Document Signature</th>
//                       <th className="py-4 md:py-5 px-4 md:px-6 text-center">Verification Status</th>
//                       <th className="py-4 md:py-5 px-4 md:px-6 text-center">Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody className="divide-y divide-gray-50">
//                     {filteredCategories.map((doc, idx) => {
//                       const docData = docs[doc.type];
//                       const isUploaded = !!docData?.url;
//                       return (
//                         <tr key={idx} className="hover:bg-gray-50/50 transition-colors group">
//                           <td className="py-5 px-8 text-left">
//                             <div className="flex items-center gap-3 md:gap-4">
//                               <div className={`w-8 h-8 md:w-10 md:h-10 rounded-xl flex items-center justify-center transition-all border shrink-0 ${isUploaded ? "bg-emerald-50 text-emerald-500 border-emerald-100 shadow-sm" : "bg-gray-50 text-gray-300 border-gray-100"}`}>
//                                 <doc.icon size={16} className="md:w-[18px] md:h-[18px]" />
//                               </div>
//                               <div className="min-w-0">
//                                 <h4 className="text-[11px] md:text-xs font-bold text-gray-900 uppercase tracking-widest truncate">{doc.title}</h4>
//                                 <p className="text-[8px] md:text-[9px] font-bold text-gray-400 uppercase tracking-widest mt-0.5 truncate">{doc.desc}</p>
//                               </div>
//                             </div>
//                           </td>
//                           <td className="py-5 px-6">
//                             {isUploaded ? (
//                               <div className="flex flex-col items-center gap-1">
//                                 <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-emerald-50 text-emerald-600 text-[10px] font-bold uppercase tracking-widest border border-emerald-100 shadow-sm">
//                                   <FiCheckCircle size={11} /> VERIFIED
//                                 </span>
//                                 {docData.uploadedAt && <span className="text-[8px] font-bold text-gray-400 uppercase tracking-widest">{new Date(docData.uploadedAt).toLocaleDateString("en-IN", { day: 'numeric', month: 'short' })}</span>}
//                               </div>
//                             ) : (
//                               <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-amber-50 text-amber-500 text-[10px] font-bold uppercase tracking-widest border border-amber-100 shadow-sm">
//                                 <FiAlertTriangle size={11} /> MISSING
//                               </span>
//                             )}
//                           </td>
//                           <td className="py-4 md:py-5 px-4 md:px-6 text-center">
//                             <div className="flex justify-center gap-2 md:gap-4">
//                                {isUploaded ? (
//                                  <>
//                                    <a href={formatDocumentUrl(docData.url)} target="_blank" rel="noreferrer" className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-xl bg-indigo-50 text-indigo-700 hover:bg-indigo-600 hover:text-white border border-indigo-100 transition-all transform active:scale-90 shadow-sm" title="View Document">
//                                      <FiEye size={14} className="md:w-4 md:h-4" />
//                                    </a>
//                                    <label className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-xl bg-gray-50 text-gray-400 hover:bg-blue-600 hover:text-white border border-gray-100 transition-all cursor-pointer active:scale-90 shadow-sm" title="Edit / Replace Document">
//                                      {uploading[doc.type] ? <FiRefreshCw size={12} className="animate-spin text-indigo-500" /> : <FiEdit size={12} />}
//                                      <input type="file" className="hidden" onChange={(e) => handleFileUpload(e, doc.type)} accept=".pdf,.png,.jpg,.jpeg" />
//                                    </label>
//                                  </>
//                                ) : (
//                                  <label className="flex items-center gap-2 px-3 md:px-4 py-2 md:py-2.5 bg-gray-900 text-white rounded-xl text-[8px] md:text-[10px] font-bold uppercase tracking-widest transition-all hover:bg-black active:scale-95 shadow-lg border border-black cursor-pointer whitespace-nowrap" title="Upload Document">
//                                    {uploading[doc.type] ? <FiRefreshCw size={11} className="animate-spin text-gray-400" /> : <FiUpload size={11} className="text-gray-400" />}
//                                    <span>UPLOAD</span>
//                                    <input type="file" className="hidden" onChange={(e) => handleFileUpload(e, doc.type)} accept=".pdf,.png,.jpg,.jpeg" />
//                                  </label>
//                                )}
//                             </div>
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </div>
//               {filteredCategories.length === 0 && (
//                 <div className="p-20 text-center">
//                   <div className="w-20 h-20 bg-gray-50 rounded-[2rem] flex items-center justify-center text-gray-200 mx-auto mb-6 border border-gray-100 shadow-inner"><FiInbox size={35} /></div>
//                   <h3 className="text-base font-bold text-gray-700 uppercase tracking-widest">No Documents Found</h3>
//                   <p className="text-[10px] font-bold text-gray-400 uppercase tracking-[0.2em] mt-2">Adjust your search parameters</p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//         </div>
//       </div>

//       <div className="mt-8 flex items-center justify-center gap-3 text-[9px] font-bold text-gray-400 uppercase tracking-[0.2em]">
//          <FiShield className="text-indigo-400" /> AES-256 Encryption Active • Timely Health Secure Storage
//       </div>

//       {/* Banking Modal */}
//       <AnimatePresence>
//         {isBankModalOpen && (
//           <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md">
//             <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }} className="bg-white w-full max-w-md rounded-3xl md:rounded-[2.5rem] shadow-2xl p-6 md:p-10 border border-gray-100 relative max-h-[95vh] overflow-y-auto">
//                <button className="absolute top-4 md:top-6 right-4 md:right-6 w-8 h-8 md:w-10 md:h-10 rounded-xl bg-gray-50 flex items-center justify-center text-gray-400 hover:text-red-500 transition-all shadow-sm border border-gray-100" onClick={() => setIsBankModalOpen(false)}><FiX size={14}/></button>
//                <div className="mb-6 md:mb-8 flex flex-col items-center text-center">
//                   <div className="w-14 h-14 md:w-16 md:h-16 bg-blue-50 text-blue-500 rounded-2xl flex items-center justify-center mb-4 shadow-inner border border-blue-100/50"><FiBriefcase size={24} className="md:w-7 md:h-7"/></div>
//                   <h3 className="text-lg md:text-xl font-bold text-gray-900 tracking-tight uppercase tracking-widest">Banking Profile</h3>
//                   <p className="text-[9px] md:text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-2">Payroll & Financial Details </p>
//                </div>


//                <form onSubmit={handleSaveBankDetails} className="space-y-5">
//                  <div className="space-y-2">
//                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Bank Name *</label>
//                    <input 
//                      type="text" 
//                      value={bankForm.bankName} 
//                      onChange={e => handleBankInputChange('bankName', e.target.value)} 
//                      maxLength={30} 
//                      className="w-full px-5 py-3.5 bg-gray-50/50 border border-gray-200 rounded-2xl focus:bg-white focus:ring-2 focus:ring-blue-500 transition-all text-sm font-bold outline-none uppercase placeholder:text-gray-300" 
//                      placeholder="e.g. HDFC BANK" 
//                      title="Only alphabets and spaces allowed"
//                    />
//                    <p className="text-[8px] text-gray-400 ml-1">Only alphabets and spaces allowed</p>
//                  </div>
//                  <div className="space-y-2">
//                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Account Number *</label>
//                    <input 
//                      type="text" 
//                      value={bankForm.accountNumber} 
//                      onChange={e => handleBankInputChange('accountNumber', e.target.value)} 
//                      maxLength={18} 
//                      className="w-full px-5 py-3.5 bg-gray-50/50 border border-gray-200 rounded-2xl focus:bg-white focus:ring-2 focus:ring-blue-500 transition-all text-sm font-bold outline-none tracking-widest placeholder:text-gray-300 placeholder:tracking-normal" 
//                      placeholder="ENTER ACCOUNT NUMBER" 
//                      title="Only numbers allowed"
//                    />
//                    <p className="text-[8px] text-gray-400 ml-1">Only numbers, 9-18 digits</p>
//                  </div>
//                  <div className="space-y-2">
//                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">IFSC Code *</label>
//                    <input 
//                      type="text" 
//                      value={bankForm.ifscCode} 
//                      onChange={e => handleBankInputChange('ifscCode', e.target.value)} 
//                      maxLength={11} 
//                      className="w-full px-5 py-3.5 bg-gray-50/50 border border-gray-200 rounded-2xl focus:bg-white focus:ring-2 focus:ring-blue-500 transition-all text-sm font-bold outline-none uppercase tracking-widest placeholder:text-gray-300 placeholder:tracking-normal" 
//                      placeholder="HDFC0001234" 
//                      title="Only alphabets and numbers allowed"
//                    />
//                    <p className="text-[8px] text-gray-400 ml-1">Only alphabets and numbers (e.g., HDFC0001234)</p>
//                  </div>

//                  <button type="submit" disabled={isSaving} className="w-full mt-8 py-4 bg-gradient-to-r from-blue-600 to-indigo-700 text-white rounded-2xl text-[10px] font-bold uppercase tracking-[0.2em] shadow-lg shadow-blue-100 hover:scale-[1.02] transition-all active:scale-95 disabled:opacity-50">
//                    {isSaving ? "Transmitting..." : "Save Bank Profile"}
//                  </button>
//                </form>
//             </motion.div>
//           </div>
//         )}
//       </AnimatePresence>

//       {/* Emergency Modal */}
//       <AnimatePresence>
//         {isEmergencyModalOpen && (
//            <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md">
//             <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }} className="bg-white w-full max-w-md rounded-3xl md:rounded-[2.5rem] shadow-2xl p-6 md:p-10 border border-gray-100 relative max-h-[95vh] overflow-y-auto">
//                <button className="absolute top-4 md:top-6 right-4 md:right-6 w-8 h-8 md:w-10 md:h-10 rounded-xl bg-gray-50 flex items-center justify-center text-gray-400 hover:text-red-500 transition-all shadow-sm border border-gray-100" onClick={() => setIsEmergencyModalOpen(false)}><FiX size={14}/></button>
//                <div className="mb-6 md:mb-8 flex flex-col items-center text-center">
//                   <div className="w-14 h-14 md:w-16 md:h-16 bg-emerald-50 text-emerald-500 rounded-2xl flex items-center justify-center mb-4 shadow-inner border border-emerald-100/50"><FiUsers size={24} className="md:w-7 md:h-7"/></div>
//                   <h3 className="text-lg md:text-xl font-bold text-gray-900 tracking-tight uppercase tracking-widest">Emergency Contact</h3>
//                   <p className="text-[9px] md:text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-2">Primary Emergency Details</p>
//                </div>


//                <form onSubmit={handleSaveEmergencyContact} className="space-y-5">
//                  <div className="space-y-2">
//                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Contact Name *</label>
//                    <input 
//                      type="text" 
//                      value={emergencyForm.name} 
//                      onChange={e => handleEmergencyInputChange('name', e.target.value)} 
//                      maxLength={30} 
//                      className="w-full px-5 py-3.5 bg-gray-50/50 border border-gray-200 rounded-2xl focus:bg-white focus:ring-2 focus:ring-emerald-500 transition-all text-sm font-bold outline-none uppercase placeholder:text-gray-300" 
//                      placeholder="ENTER FULL NAME" 
//                      title="Only alphabets and spaces allowed"
//                    />
//                    <p className="text-[8px] text-gray-400 ml-1">Only alphabets and spaces allowed</p>
//                  </div>
//                  <div className="space-y-2">
//                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Phone Number *</label>
//                    <input 
//                      type="tel" 
//                      value={emergencyForm.phone} 
//                      onChange={e => handleEmergencyInputChange('phone', e.target.value)} 
//                      maxLength={10} 
//                      className="w-full px-5 py-3.5 bg-gray-50/50 border border-gray-200 rounded-2xl focus:bg-white focus:ring-2 focus:ring-emerald-500 transition-all text-sm font-bold outline-none tracking-widest placeholder:text-gray-300 placeholder:tracking-normal" 
//                      placeholder="E.G. 9000000000" 
//                      title="10 digits starting with 6, 7, 8, or 9"
//                    />
//                    <p className="text-[8px] text-gray-400 ml-1">10 digits starting with 6, 7, 8, or 9</p>
//                  </div>
//                  <div className="space-y-2">
//                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Relationship *</label>
//                    <input 
//                      type="text" 
//                      value={emergencyForm.relationship} 
//                      onChange={e => handleEmergencyInputChange('relationship', e.target.value)} 
//                      maxLength={20} 
//                      className="w-full px-5 py-3.5 bg-gray-50/50 border border-gray-200 rounded-2xl focus:bg-white focus:ring-2 focus:ring-emerald-500 transition-all text-sm font-bold outline-none uppercase placeholder:text-gray-300" 
//                      placeholder="E.G. SPOUSE" 
//                      title="Only alphabets and spaces allowed"
//                    />
//                    <p className="text-[8px] text-gray-400 ml-1">Only alphabets and spaces allowed</p>
//                  </div>

//                  <button type="submit" disabled={isSaving} className="w-full mt-8 py-4 bg-gradient-to-r from-emerald-500 to-teal-600 text-white rounded-2xl text-[10px] font-bold uppercase tracking-[0.2em] shadow-lg shadow-emerald-100 hover:scale-[1.02] transition-all active:scale-95 disabled:opacity-50">
//                    {isSaving ? "Transmitting..." : "Save Liaison Data"}
//                  </button>
//                </form>
//             </motion.div>
//           </div>
//         )}
//       </AnimatePresence>

//       {/* Personal Details Modal */}
//       <AnimatePresence>
//         {isPersonalModalOpen && (
//           <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md">
//             <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }} className="bg-white w-full max-w-2xl rounded-3xl md:rounded-[2.5rem] shadow-2xl p-6 md:p-10 border border-gray-100 relative max-h-[90vh] overflow-y-auto custom-scrollbar">
//                <button className="absolute top-4 md:top-6 right-4 md:right-6 w-8 h-8 md:w-10 md:h-10 rounded-xl bg-gray-50 flex items-center justify-center text-gray-400 hover:text-red-500 transition-all shadow-sm border border-gray-100" onClick={() => setIsPersonalModalOpen(false)}><FiX size={14}/></button>
//                <div className="mb-6 md:mb-8 flex flex-col items-center text-center">
//                   <div className="w-14 h-14 md:w-16 md:h-16 bg-indigo-50 text-indigo-500 rounded-2xl flex items-center justify-center mb-4 shadow-inner border border-indigo-100/50"><FiCreditCard size={24} className="md:w-7 md:h-7"/></div>
//                   <h3 className="text-lg md:text-xl font-bold text-gray-900 tracking-tight uppercase tracking-widest">Personal Details</h3>
//                   <p className="text-[9px] md:text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-2">Candidate Profile</p>
//                </div>


//                <form onSubmit={handleSavePersonalDetails} className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                   <div className="space-y-2">
//                     <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Full Name *</label>
//                     <input 
//                       type="text" 
//                       value={personalForm.name} 
//                       onChange={e => handlePersonalInputChange('name', e.target.value)} 
//                       maxLength={30} 
//                       className="w-full px-5 py-3 bg-gray-50/50 border border-gray-200 rounded-2xl focus:bg-white focus:ring-2 focus:ring-indigo-500 transition-all text-sm font-bold outline-none" 
//                       placeholder="Enter full name (alphabets only)" 
//                       title="Only alphabets and spaces are allowed"
//                     />
//                     <p className="text-[8px] text-gray-400 ml-1">Only alphabets and spaces allowed</p>
//                   </div>
//                   <div className="space-y-2">
//                     <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Phone Number *</label>
//                     <input 
//                       type="tel" 
//                       value={personalForm.phone} 
//                       onChange={e => handlePersonalInputChange('phone', e.target.value)} 
//                       maxLength={10} 
//                       className="w-full px-5 py-3 bg-gray-50/50 border border-gray-200 rounded-2xl focus:bg-white focus:ring-2 focus:ring-indigo-500 transition-all text-sm font-bold outline-none" 
//                       placeholder="9000000000" 
//                       title="10 digits starting with 6, 7, 8, or 9"
//                     />
//                     <p className="text-[8px] text-gray-400 ml-1">10 digits starting with 6, 7, 8, or 9</p>
//                   </div>
//                   <div className="space-y-2">
//                     <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Date of Birth</label>
//                     <input 
//                       type="date" 
//                       value={personalForm.dob} 
//                       onChange={e => setPersonalForm({...personalForm, dob: e.target.value})} 
//                       max={formatDateForDisplay(new Date())}
//                       className="w-full px-5 py-3 bg-gray-50/50 border border-gray-200 rounded-2xl focus:bg-white focus:ring-2 focus:ring-indigo-500 transition-all text-sm font-bold outline-none" 
//                     />
//                   </div>
//                   <div className="space-y-2">
//                     <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Gender</label>
//                     <select value={personalForm.gender} onChange={e => setPersonalForm({...personalForm, gender: e.target.value})} className="w-full px-5 py-3 bg-gray-50/50 border border-gray-200 rounded-2xl focus:bg-white focus:ring-2 focus:ring-indigo-500 transition-all text-sm font-bold outline-none">
//                       <option value="">Select Gender</option>
//                       <option value="Male">Male</option>
//                       <option value="Female">Female</option>
//                       <option value="Other">Other</option>
//                       <option value="Prefer not to say">Prefer not to say</option>
//                     </select>
//                   </div>
//                   <div className="md:col-span-2 space-y-2">
//                     <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Current Address *</label>
//                     <input 
//                       type="text" 
//                       value={personalForm.address} 
//                       onChange={e => handlePersonalInputChange('address', e.target.value)} 
//                       maxLength={50} 
//                       className="w-full px-5 py-3 bg-gray-50/50 border border-gray-200 rounded-2xl focus:bg-white focus:ring-2 focus:ring-indigo-500 transition-all text-sm font-bold outline-none" 
//                       placeholder="Road Number, Street Name, Landmark" 
//                       title="Alphabets, numbers, spaces, and common punctuation allowed"
//                     />
//                     <p className="text-[8px] text-gray-400 ml-1">Alphabets, numbers, spaces, . , - allowed</p>
//                   </div>
//                   <div className="space-y-2">
//                     <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">City *</label>
//                     <input 
//                       type="text" 
//                       value={personalForm.city} 
//                       onChange={e => handlePersonalInputChange('city', e.target.value)} 
//                       maxLength={20} 
//                       className="w-full px-5 py-3 bg-gray-50/50 border border-gray-200 rounded-2xl focus:bg-white focus:ring-2 focus:ring-indigo-500 transition-all text-sm font-bold outline-none" 
//                       placeholder="City" 
//                       title="Only alphabets and spaces allowed"
//                     />
//                     <p className="text-[8px] text-gray-400 ml-1">Only alphabets and spaces allowed</p>
//                   </div>
//                   <div className="space-y-2">
//                     <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">State *</label>
//                     <input 
//                       type="text" 
//                       value={personalForm.state} 
//                       onChange={e => handlePersonalInputChange('state', e.target.value)} 
//                       maxLength={20} 
//                       className="w-full px-5 py-3 bg-gray-50/50 border border-gray-200 rounded-2xl focus:bg-white focus:ring-2 focus:ring-indigo-500 transition-all text-sm font-bold outline-none" 
//                       placeholder="State" 
//                       title="Only alphabets and spaces allowed"
//                     />
//                     <p className="text-[8px] text-gray-400 ml-1">Only alphabets and spaces allowed</p>
//                   </div>
//                   <div className="space-y-2">
//                     <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Pincode *</label>
//                     <input
//                       type="text"
//                       value={personalForm.pincode}
//                       onChange={e => handlePersonalInputChange('pincode', e.target.value)}
//                       maxLength={6}
//                       className="w-full px-5 py-3 bg-gray-50/50 border border-gray-200 rounded-2xl focus:bg-white focus:ring-2 focus:ring-indigo-500 transition-all text-sm font-bold outline-none"
//                       placeholder="Pincode"
//                       title="Exactly 6 digits"
//                     />
//                     <p className="text-[8px] text-gray-400 ml-1">Exactly 6 digits</p>
//                   </div>

//                   <div className="md:col-span-2 space-y-2">
//                     <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Desired Roles (Select Multiple)</label>
//                     <div className="relative" ref={roleDropdownRef}>
//                       <div
//                         onClick={() => setShowRoleDropdown(!showRoleDropdown)}
//                         className="w-full min-h-[50px] px-4 py-2.5 bg-gray-50/50 border border-gray-200 rounded-2xl focus-within:ring-2 focus-within:ring-indigo-500 outline-none transition-all text-sm font-bold text-gray-700 flex flex-wrap gap-2 items-center cursor-pointer"
//                       >
//                         {personalForm.role.length === 0 ? (
//                           <span className="text-gray-400">Select roles...</span>
//                         ) : (
//                           personalForm.role.map((role) => (
//                             <span
//                               key={role}
//                               className="bg-indigo-50 text-indigo-600 px-3 py-1 rounded-lg text-xs font-bold flex items-center gap-1.5"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleRoleToggle(role);
//                               }}
//                             >
//                               {role}
//                               <FiX className="hover:text-indigo-800 cursor-pointer" />
//                             </span>
//                           ))
//                         )}
//                       </div>
//                       <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-gray-300">
//                         <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
//                           <path d="m6 9 6 6 6-6" />
//                         </svg>
//                       </div>

//                       {showRoleDropdown && (
//                         <div className="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-2xl shadow-lg max-h-60 overflow-y-auto no-scrollbar p-2 space-y-1">
//                           <div className="px-1 py-1 sticky top-0 bg-white border-b border-gray-100 mb-2 z-10">
//                             <input
//                               type="text"
//                               value={roleSearch}
//                               onChange={(e) => setRoleSearch(e.target.value)}
//                               placeholder="Search roles..."
//                               className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-xs outline-none focus:border-indigo-600 font-medium"
//                               onClick={(e) => e.stopPropagation()}
//                             />
//                           </div>
//                           {availableRoles.filter(role => role.toLowerCase().includes(roleSearch.toLowerCase())).length === 0 ? (
//                             <div className="p-3 text-xs text-gray-400 text-center font-bold uppercase">No matching roles</div>
//                           ) : (
//                             availableRoles.filter(role => role.toLowerCase().includes(roleSearch.toLowerCase())).map((role) => {
//                               const isSelected = personalForm.role.includes(role);
//                               return (
//                                 <div
//                                   key={role}
//                                   onClick={() => handleRoleToggle(role)}
//                                   className={`px-3 py-2 text-xs font-bold rounded-lg cursor-pointer flex items-center justify-between transition-colors ${
//                                     isSelected
//                                       ? "bg-indigo-50 text-indigo-600"
//                                       : "text-gray-600 hover:bg-gray-50"
//                                   }`}
//                                 >
//                                   <span>{role}</span>
//                                   {isSelected && <FiCheckCircle className="text-indigo-600" />}
//                                 </div>
//                               );
//                             })
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   <div className="md:col-span-2 pt-4">
//                     <button type="submit" disabled={isSaving} className="w-full py-4 bg-gradient-to-r from-indigo-600 to-purple-700 text-white rounded-2xl text-[10px] font-bold uppercase tracking-[0.2em] shadow-lg shadow-indigo-100 hover:scale-[1.01] transition-all active:scale-95 disabled:opacity-50">
//                       {isSaving ? "Synchronizing..." : "Save Profile Details"}
//                     </button>
//                   </div>
//                 </form>
//             </motion.div>
//           </div>
//         )}
//       </AnimatePresence>
//       </div>
//     </div>
//   );
// };

// export default CandidatePersonalDocuments;





import React, { useState, useEffect, useMemo, useRef } from "react";
import { useToast } from "../context/ToastContext";
import { useOutletContext } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import { API_BASE_URL } from "../utils/config";
import MedicalCertificate from './MedicalCertificate';
import CandidateEducation from './CandidateEducation';
import {
  FiCreditCard, FiShield, FiUsers,
  FiUpload, FiCheckCircle, FiAlertTriangle, FiEye,
  FiX, FiRefreshCw, FiBriefcase, FiPhone,
  FiEdit, FiInbox, FiFile, FiAward, FiImage,
  FiMapPin, FiClock, FiArrowRight
} from "react-icons/fi";
import "./EmployeeDashboard.css";

const CandidatePersonalDocuments = () => {
  const { showToast } = useToast();
  const { personalDocs, fetchDashboardData, formatDocumentUrl, profile, setProfile } = useOutletContext();
  const docs = useMemo(() => personalDocs?.documents || personalDocs || {}, [personalDocs]);
  const [uploading, setUploading] = useState({});
  const [localSearch, setLocalSearch] = useState("");

  // Helper: get best available auth header or candidateId
  const getAuthHeaders = () => {
    const token = localStorage.getItem("candidateToken");
    if (token && token !== "null" && token !== "undefined") {
      return { Authorization: `Bearer ${token}` };
    }
    return {};
  };

  const getCandidateId = () => {
    return profile?._id || localStorage.getItem("candidateId") || null;
  };

  const [isBankModalOpen, setIsBankModalOpen] = useState(false);
  const [isEmergencyModalOpen, setIsEmergencyModalOpen] = useState(false);
  const [isPersonalModalOpen, setIsPersonalModalOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  // Validation errors state
  const [bankErrors, setBankErrors] = useState({});
  const [emergencyErrors, setEmergencyErrors] = useState({});
  const [personalErrors, setPersonalErrors] = useState({});

  const [bankForm, setBankForm] = useState({ bankName: "", accountNumber: "", ifscCode: "" });
  const [emergencyForm, setEmergencyForm] = useState({ name: "", phone: "", relationship: "" });
  const [personalForm, setPersonalForm] = useState({
    name: "", phone: "", address: "",
    dob: "", gender: "", city: "", state: "", pincode: "", role: []
  });

  const [availableRoles, setAvailableRoles] = useState([]);
  const [showRoleDropdown, setShowRoleDropdown] = useState(false);
  const [roleSearch, setRoleSearch] = useState("");
  const roleDropdownRef = useRef(null);
  const [matchedJobs, setMatchedJobs] = useState([]);
  const [loadingJobs, setLoadingJobs] = useState(false);

  // Fetch available roles
  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/roles/all`);
        let rolesData = [];
        if (Array.isArray(res.data)) rolesData = res.data;
        else if (Array.isArray(res.data.data)) rolesData = res.data.data;
        else if (Array.isArray(res.data.roles)) rolesData = res.data.roles;

        const uniqueRoles = rolesData.map((r, index) => {
          if (typeof r === 'string') return r;
          return r.name || r.title || r.role || "";
        }).filter(r => r !== "");

        setAvailableRoles([...new Set(uniqueRoles)]);
      } catch (err) {
        console.error("Failed to fetch roles:", err);
      }
    };
    fetchRoles();
  }, []);

  // Handle role dropdown click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (roleDropdownRef.current && !roleDropdownRef.current.contains(event.target)) {
        setShowRoleDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Clear role search when dropdown closes
  useEffect(() => {
    if (!showRoleDropdown) {
      setRoleSearch("");
    }
  }, [showRoleDropdown]);

  // Handle role toggle
  const handleRoleToggle = (role) => {
    setPersonalForm(prev => ({
      ...prev,
      role: prev.role.includes(role)
        ? prev.role.filter(r => r !== role)
        : [...prev.role, role]
    }));
  };

  // Fetch matched jobs based on candidate's desired roles
  useEffect(() => {
    const fetchMatchedJobs = async () => {
      // Get roles from profile or personalForm
      const currentRoles = personalForm.role && personalForm.role.length > 0 
        ? personalForm.role 
        : (profile?.roles || profile?.role || []);
      
      if (!currentRoles || currentRoles.length === 0) {
        setMatchedJobs([]);
        return;
      }

      setLoadingJobs(true);
      try {
        const res = await axios.get(`${API_BASE_URL}/jobs/all`);
        if (res.data.success) {
          const allJobs = res.data.data || res.data.jobPosts || [];

          // Filter jobs that match candidate's roles using partial matching
          const candidateRoles = Array.isArray(currentRoles) ? currentRoles : [currentRoles];
          const matched = allJobs.filter(job => {
            return candidateRoles.some(role => {
              const candidateRole = role.toLowerCase().trim();
              const jobRole = (job.role || "").toLowerCase().trim();
              return jobRole.includes(candidateRole) || candidateRole.includes(jobRole);
            });
          });

          setMatchedJobs(matched.slice(0, 5));
        }
      } catch (err) {
        console.error("Failed to fetch matched jobs:", err);
      } finally {
        setLoadingJobs(false);
      }
    };

    fetchMatchedJobs();
  }, [profile?.role, profile?.roles, personalForm.role]);

  // Helper function to format date for display (local time)
  const formatDateForDisplay = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "";
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    } catch (error) {
      return "";
    }
  };

  // Validation helper functions
  const validateAlphabetsOnly = (value) => {
    return /^[A-Za-z\s]*$/.test(value);
  };

  const validateAlphabetsAndNumbersOnly = (value) => {
    return /^[A-Za-z0-9]*$/.test(value);
  };

  const validateNumbersOnly = (value) => {
    return /^\d*$/.test(value);
  };

  // Enhanced Indian phone number validation - exactly 10 digits starting with 6-9
  const validatePhoneNumber = (value) => {
    return /^[6-9]\d{9}$/.test(value);
  };

  const validatePincode = (value) => {
    return /^\d{6}$/.test(value);
  };

  // Input handlers with validation
  const handlePersonalInputChange = (field, value) => {
    // Clear error for this field when user starts typing
    setPersonalErrors(prev => ({ ...prev, [field]: '' }));

    // For name field - only alphabets and spaces
    if (field === 'name') {
      if (value === '' || validateAlphabetsOnly(value)) {
        setPersonalForm({...personalForm, [field]: value});
      }
      return;
    }
    
    // Phone field validation - only numbers, must start with 6-9, max 10 digits
    if (field === 'phone') {
      if (value === '') {
        setPersonalForm({...personalForm, [field]: value});
        return;
      }
      if (/^\d*$/.test(value)) {
        if (value.length === 0 || /^[6-9]/.test(value.charAt(0))) {
          if (value.length <= 10) {
            setPersonalForm({...personalForm, [field]: value});
          }
        }
      }
      return;
    }

    // For pincode field - only numbers, exactly 6 digits
    if (field === 'pincode') {
      if (value === '' || /^\d{0,6}$/.test(value)) {
        setPersonalForm({...personalForm, [field]: value});
      }
      return;
    }

    // For address field - alphabets, numbers, spaces, and common punctuation
    if (field === 'address') {
      if (value === '' || /^[A-Za-z0-9\s,.-]*$/.test(value)) {
        setPersonalForm({...personalForm, [field]: value});
      }
      return;
    }

    // For city and state fields - only alphabets and spaces
    if (field === 'city' || field === 'state') {
      if (value === '' || validateAlphabetsOnly(value)) {
        setPersonalForm({...personalForm, [field]: value});
      }
      return;
    }

    // For other fields
    setPersonalForm({...personalForm, [field]: value});
  };

  // Bank form input handlers
  const handleBankInputChange = (field, value) => {
    setBankErrors(prev => ({ ...prev, [field]: '' }));

    if (field === 'bankName') {
      if (value === '' || validateAlphabetsOnly(value)) {
        setBankForm({...bankForm, [field]: value.toUpperCase()});
      }
      return;
    }

    if (field === 'accountNumber') {
      if (value === '' || validateNumbersOnly(value)) {
        setBankForm({...bankForm, [field]: value});
      }
      return;
    }

    if (field === 'ifscCode') {
      if (value === '' || validateAlphabetsAndNumbersOnly(value)) {
        setBankForm({...bankForm, [field]: value.toUpperCase()});
      }
      return;
    }
  };

  // Emergency form input handlers
  const handleEmergencyInputChange = (field, value) => {
    setEmergencyErrors(prev => ({ ...prev, [field]: '' }));

    if (field === 'name' || field === 'relationship') {
      if (value === '' || validateAlphabetsOnly(value)) {
        setEmergencyForm({...emergencyForm, [field]: value.toUpperCase()});
      }
      return;
    }
    
    if (field === 'phone') {
      if (value === '') {
        setEmergencyForm({...emergencyForm, [field]: value});
        return;
      }
      if (/^\d*$/.test(value)) {
        if (value.length === 0 || /^[6-9]/.test(value.charAt(0))) {
          if (value.length <= 10) {
            setEmergencyForm({...emergencyForm, [field]: value});
          }
        }
      }
      return;
    }
  };

  useEffect(() => {
    if (docs.bankDetails) {
      setBankForm({
        bankName: docs.bankDetails.bankName || "",
        accountNumber: docs.bankDetails.accountNumber || "",
        ifscCode: docs.bankDetails.ifscCode || ""
      });
    }
    if (docs.emergencyContact1) {
      setEmergencyForm({
        name: docs.emergencyContact1.name || "",
        phone: docs.emergencyContact1.phone || "",
        relationship: docs.emergencyContact1.relationship || ""
      });
    }
    if (profile) {
      const formattedDob = formatDateForDisplay(profile.dob);
      
      // Get roles from profile - try both possible field names
      const userRoles = profile.roles || profile.role || [];
      
      setPersonalForm({
        name: profile.name || "",
        phone: profile.phone || "",
        address: profile.address || "",
        dob: formattedDob,
        gender: profile.gender || "",
        city: profile.city || "",
        state: profile.state || "",
        pincode: profile.pincode || "",
        role: Array.isArray(userRoles) ? userRoles : []
      });
    }
  }, [docs, profile]);

  // Validate bank form
  const validateBankForm = () => {
    const errors = {};
    
    if (!bankForm.bankName || bankForm.bankName.trim().length < 3) {
      errors.bankName = "Bank name must be at least 3 characters";
    } else if (!validateAlphabetsOnly(bankForm.bankName)) {
      errors.bankName = "Only alphabets and spaces allowed";
    }
    
    if (!bankForm.accountNumber || !/^\d{9,18}$/.test(bankForm.accountNumber)) {
      errors.accountNumber = "Account number must be 9-18 digits";
    }
    
    if (!bankForm.ifscCode || !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(bankForm.ifscCode.toUpperCase())) {
      errors.ifscCode = "Invalid IFSC code format (e.g., HDFC0001234)";
    }

    setBankErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Validate emergency form
  const validateEmergencyForm = () => {
    const errors = {};
    
    if (!emergencyForm.name || emergencyForm.name.trim().length < 2) {
      errors.name = "Contact name must be at least 2 characters";
    } else if (!validateAlphabetsOnly(emergencyForm.name)) {
      errors.name = "Only alphabets and spaces allowed";
    }
    
    if (!emergencyForm.phone || !validatePhoneNumber(emergencyForm.phone)) {
      errors.phone = "10 digits starting with 6, 7, 8, or 9";
    }
    
    if (!emergencyForm.relationship || emergencyForm.relationship.trim().length < 2) {
      errors.relationship = "Relationship must be at least 2 characters";
    } else if (!validateAlphabetsOnly(emergencyForm.relationship)) {
      errors.relationship = "Only alphabets and spaces allowed";
    }

    setEmergencyErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Validate personal form
  const validatePersonalForm = () => {
    const errors = {};
    
    if (!personalForm.name || personalForm.name.trim().length < 2) {
      errors.name = "Full name must be at least 2 characters";
    } else if (!validateAlphabetsOnly(personalForm.name)) {
      errors.name = "Only alphabets and spaces allowed";
    }
    
    if (!personalForm.phone || !validatePhoneNumber(personalForm.phone)) {
      errors.phone = "10 digits starting with 6, 7, 8, or 9";
    }

    // // Address validation
    // if (!personalForm.address || personalForm.address.trim().length < 5) {
    //   errors.address = "Address must be at least 5 characters";
    // }

    // // City validation
    // if (!personalForm.city || personalForm.city.trim().length < 2) {
    //   errors.city = "City must be at least 2 characters";
    // } else if (!validateAlphabetsOnly(personalForm.city)) {
    //   errors.city = "Only alphabets and spaces allowed";
    // }

    // // State validation
    // if (!personalForm.state || personalForm.state.trim().length < 2) {
    //   errors.state = "State must be at least 2 characters";
    // } else if (!validateAlphabetsOnly(personalForm.state)) {
    //   errors.state = "Only alphabets and spaces allowed";
    // }

    // Pincode validation
    if (!personalForm.pincode || !validatePincode(personalForm.pincode)) {
      errors.pincode = "Exactly 6 digits required";
    }

    setPersonalErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFileUpload = async (event, type) => {
    const file = event.target.files[0];
    if (!file) return;
    setUploading({ ...uploading, [type]: true });
    const formData = new FormData();
    formData.append("document", file);
    formData.append("type", type);
    const candidateId = getCandidateId();
    if (candidateId) formData.append("candidateId", candidateId);
    try {
      await axios.post(`${API_BASE_URL}/candidate/documents/upload`, formData, {
        headers: { ...getAuthHeaders(), 'Content-Type': 'multipart/form-data' }
      });
      fetchDashboardData();
    } catch (err) {
      console.error(`Upload error for ${type}:`, err);
      showToast("Failed to upload document. Please make sure you are logged in.", "error");
    } finally {
      setUploading({ ...uploading, [type]: false });
    }
  };

  const handleSaveBankDetails = async (e) => {
    if (e) e.preventDefault();

    if (!validateBankForm()) {
      return;
    }

    setIsSaving(true);
    try {
      await axios.post(`${API_BASE_URL}/candidate/save-bank-details`,
        { bankDetails: bankForm, candidateId: getCandidateId() },
        { headers: getAuthHeaders() }
      );
      showToast("Bank details saved successfully", "success");
      fetchDashboardData();
      setIsBankModalOpen(false);
      setBankErrors({});
    } catch (err) {
      console.error(err);
      showToast(err.response?.data?.message || "Failed to save bank details", "error");
    } finally {
      setIsSaving(false);
    }
  };

  const handleSaveEmergencyContact = async (e) => {
    if (e) e.preventDefault();

    if (!validateEmergencyForm()) {
      return;
    }

    setIsSaving(true);
    try {
      await axios.post(`${API_BASE_URL}/candidate/save-emergency-contact`,
        { contactNumber: 1, contact: emergencyForm, candidateId: getCandidateId() },
        { headers: getAuthHeaders() }
      );
      showToast("Emergency contact saved successfully", "success");
      fetchDashboardData();
      setIsEmergencyModalOpen(false);
      setEmergencyErrors({});
    } catch (err) {
      console.error(err);
      showToast(err.response?.data?.message || "Failed to save contact", "error");
    } finally {
      setIsSaving(false);
    }
  };

  // UPDATED: Fixed handleSavePersonalDetails with proper error handling
  const handleSavePersonalDetails = async (e) => {
    if (e) e.preventDefault();

    if (!validatePersonalForm()) {
      return;
    }

    setIsSaving(true);
    try {
      const candidateId = getCandidateId();
      const roles = personalForm.role || [];
      
      // Log current state
      console.log("Current roles in form:", roles);
      console.log("Current profile roles:", profile?.roles || profile?.role);
      console.log("Candidate ID:", candidateId);
      
      // Create payload with all fields
      const payload = {
        name: personalForm.name,
        phone: personalForm.phone,
        address: personalForm.address,
        dob: personalForm.dob,
        gender: personalForm.gender,
        city: personalForm.city,
        state: personalForm.state,
        pincode: personalForm.pincode,
        // Send roles in multiple formats to ensure backend receives them
        role: roles,
        roles: roles,
        desiredRoles: roles,
        candidateId: candidateId
      };
      
      console.log("Sending payload to update profile:", JSON.stringify(payload, null, 2));
      
      // Try multiple approaches to update roles
      let response = null;
      let roleUpdateSuccess = false;
      
      // Approach 1: Update complete profile using PUT
      try {
        console.log("Attempting to update full profile with PUT...");
        response = await axios.put(`${API_BASE_URL}/candidate/profile`, payload, {
          headers: getAuthHeaders()
        });
        console.log("Full profile update response:", response.data);
        roleUpdateSuccess = true;
      } catch (putError) {
        console.log("Full profile update failed:", putError.response?.status, putError.response?.data);
        
        // Approach 2: If PUT fails with 404, try POST
        if (putError.response?.status === 404) {
          try {
            console.log("Attempting POST to create/update profile...");
            response = await axios.post(`${API_BASE_URL}/candidate/profile`, payload, {
              headers: getAuthHeaders()
            });
            console.log("POST profile update response:", response.data);
            roleUpdateSuccess = true;
          } catch (postError) {
            console.log("POST profile update failed:", postError.response?.data);
          }
        }
      }
      
      // If all attempts failed, show error
      if (!roleUpdateSuccess) {
        showToast("Could not update profile. Please try again.", "error");
        setIsSaving(false);
        return;
      }
      
      showToast("Personal details updated successfully", "success");
      
      // Fetch dashboard data to refresh profile
      await fetchDashboardData();
      
      // Instead of trying to fetch profile separately, use the response data
      if (response && response.data) {
        // If response contains updated profile, use it
        if (response.data.profile) {
          console.log("Updated profile from response:", response.data.profile);
          // Update local personalForm with refreshed data
          const updatedRoles = response.data.profile.roles || response.data.profile.role || [];
          setPersonalForm(prev => ({
            ...prev,
            role: Array.isArray(updatedRoles) ? updatedRoles : []
          }));
          
          // If setProfile is available, update it
          if (setProfile && response.data.profile) {
            setProfile(response.data.profile);
          }
        } else if (response.data.data && response.data.data.profile) {
          // Handle nested response structure
          const profileData = response.data.data.profile;
          const updatedRoles = profileData.roles || profileData.role || [];
          setPersonalForm(prev => ({
            ...prev,
            role: Array.isArray(updatedRoles) ? updatedRoles : []
          }));
          
          if (setProfile) {
            setProfile(profileData);
          }
        }
      }
      
      // Update matched jobs with new roles
      if (roles.length > 0) {
        setLoadingJobs(true);
        try {
          const res = await axios.get(`${API_BASE_URL}/jobs/all`);
          if (res.data.success) {
            const allJobs = res.data.data || res.data.jobPosts || [];
            const candidateRoles = Array.isArray(roles) ? roles : [roles];
            const matched = allJobs.filter(job => {
              return candidateRoles.some(role => {
                const candidateRole = role.toLowerCase().trim();
                const jobRole = (job.role || "").toLowerCase().trim();
                return jobRole.includes(candidateRole) || candidateRole.includes(jobRole);
              });
            });
            setMatchedJobs(matched.slice(0, 15));
          }
        } catch (err) {
          console.error("Failed to fetch matched jobs after update:", err);
        } finally {
          setLoadingJobs(false);
        }
      } else {
        setMatchedJobs([]);
      }
      
      setIsPersonalModalOpen(false);
      setPersonalErrors({});
    } catch (err) {
      console.error("Error updating profile:", err);
      showToast(err.response?.data?.message || "Failed to update profile", "error");
    } finally {
      setIsSaving(false);
    }
  };

  const docCategories = [
    { title: "Aadhar / National ID", type: "aadharCard", icon: FiCreditCard, desc: "National Identity" },
    { title: "PAN Card", type: "panCard", icon: FiCreditCard, desc: "Tax Identity" },
    { title: "10th Certificate", type: "tenthCertificate", icon: FiFile, desc: "Educational Record" },
    { title: "12th Certificate", type: "twelfthCertificate", icon: FiFile, desc: "Educational Record" },
    { title: "Graduation Degree", type: "graduationCertificate", icon: FiAward, desc: "Higher Education" },
    { title: "Passport Photo", type: "passportPhoto", icon: FiImage, desc: "Identity Photo" }
  ];

  const filteredCategories = docCategories.filter(cat => 
    cat.title.toLowerCase().includes(localSearch.toLowerCase()) ||
    cat.desc.toLowerCase().includes(localSearch.toLowerCase())
  );

  return (
    <div className="emp-dash">
      <div className="p-4 sm:p-6 lg:p-8">
        {/* Dashboard Header */}
        <div className="emp-dash__header">
          <div>
            <h1 className="emp-dash__greeting">
              Personal <span>Documents</span>
            </h1>
            <p className="emp-dash__subtitle">
              Manage your identity and verification documents
            </p>
          </div>
          <div className="emp-dash__date-pill">
            <FiShield />
            <span>
              {new Date().toLocaleDateString("en-US", {
                weekday: "short",
                year: "numeric",
                month: "short",
                day: "numeric",
              })}
            </span>
          </div>
        </div>

        {/* Personal Details Section */}
        <div className="emp-dash__card mb-6">
          <div className="emp-dash__card-header">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-indigo-50 to-indigo-100 text-indigo-600 flex items-center justify-center shadow-inner border border-indigo-200/50">
                <FiCreditCard size={24} />
              </div>
              <div>
                <h3 className="emp-dash__card-title">Personal Profile</h3>
                <p className="emp-dash__card-desc">Core identity & verification data</p>
              </div>
            </div>
            <button 
              onClick={() => setIsPersonalModalOpen(true)}
              className="flex items-center gap-2 px-5 py-2.5 bg-indigo-600 text-white rounded-xl text-xs font-bold uppercase tracking-widest hover:bg-indigo-700 transition-all shadow-lg shadow-indigo-100 active:scale-95"
            >
              <FiEdit size={14} /> Edit Details
            </button>
          </div>
          <div className="emp-dash__card-body bg-gray-50/50">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6">
              <div className="space-y-1">
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Full Name</p>
                <p className="text-sm font-bold text-gray-900 uppercase tracking-tight">{profile?.name || "Not set"}</p>
              </div>
              <div className="space-y-1">
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Phone Number</p>
                <p className="text-sm font-bold text-gray-900 tracking-tight">{profile?.phone || "Not set"}</p>
              </div>
              <div className="space-y-1">
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Date of Birth</p>
                <p className="text-sm font-bold text-gray-900 tracking-tight">
                  {profile?.dob ? new Date(profile.dob).toLocaleDateString('en-IN', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                  }) : "Not set"}
                </p>
              </div>
              <div className="space-y-1">
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Gender</p>
                <p className="text-sm font-bold text-gray-900 uppercase tracking-tight">{profile?.gender || "Not set"}</p>
              </div>
              <div className="lg:col-span-1 space-y-1">
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Current Address</p>
                <p className="text-sm font-bold text-gray-900 uppercase tracking-tight leading-relaxed">
                  {profile?.address ? `${profile.address}, ${profile.city || ""}, ${profile.state || ""} - ${profile.pincode || ""}` : "Not set"}
                </p>
              </div>
              <div className="lg:col-span-5 space-y-1">
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Desired Roles</p>
                <div className="flex flex-wrap gap-2 mt-1">
                  {(() => {
                    // Try both possible field names
                    const roles = profile?.roles || profile?.role || [];
                    if (roles.length === 0) {
                      return <p className="text-sm font-bold text-gray-400 italic">Not set</p>;
                    }
                    return roles.map((role, index) => (
                      <span key={index} className="px-3 py-1 bg-indigo-50 text-indigo-600 rounded-lg text-xs font-bold uppercase tracking-wider border border-indigo-100">
                        {role}
                      </span>
                    ));
                  })()}
                </div>
              </div>
            </div>
          </div>

          {loadingJobs && (
            <div className="border-t border-gray-200 pt-6 mt-6">
              <div className="flex items-center justify-center py-4">
                <div className="w-6 h-6 border-2 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
              </div>
            </div>
          )}
        </div>

        <CandidateEducation />
        <MedicalCertificate />

        {/* Personal Documents Section */}
        <div className="emp-dash__card mb-6">
          <div className="emp-dash__card-header">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-indigo-50 to-indigo-100 text-indigo-600 flex items-center justify-center shadow-inner border border-indigo-200/50">
                <FiShield size={24} />
              </div>
              <div>
                <h3 className="emp-dash__card-title">Personal Documents</h3>
                <p className="emp-dash__card-desc">Verification & banking vault</p>
              </div>
            </div>
          </div>

          <div className="emp-dash__card-body bg-gray-50/50">
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
              
              {/* Details Sidebar - Summary Cards */}
              <div className="lg:col-span-1 space-y-6">
                <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-gray-100 relative group transition-all hover:shadow-md md:min-h-[280px] flex flex-col justify-between">
                  <div className="flex items-center justify-between mb-5">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center shadow-sm border border-blue-100/50">
                        <FiBriefcase size={18} />
                      </div>
                      <div>
                        <h3 className="text-xs font-bold text-gray-800 uppercase tracking-widest">Bank Profile</h3>
                        <p className="text-[8px] font-bold text-gray-400 uppercase tracking-[0.2em] mt-0.5">Payroll Source</p>
                      </div>
                    </div>
                    <button onClick={() => setIsBankModalOpen(true)} className="w-8 h-8 rounded-lg bg-gray-50 hover:bg-blue-600 hover:text-white text-gray-400 flex items-center justify-center transition-all shadow-sm border border-gray-100">
                      <FiEdit size={12}/>
                    </button>
                  </div>
                  
                  {docs.bankDetails?.accountNumber ? (
                    <div className="space-y-3">
                      <div className="p-4 bg-gray-50/50 rounded-xl border border-gray-100/50">
                        <p className="text-[9px] font-bold text-gray-400 uppercase tracking-widest">Institution</p>
                        <p className="text-xs font-bold text-gray-800 mt-1 uppercase tracking-tight">{docs.bankDetails.bankName}</p>
                      </div>
                      <div className="p-4 bg-gray-50/50 rounded-xl border border-gray-100/50 font-mono">
                        <p className="text-[9px] font-bold text-gray-400 uppercase font-sans tracking-widest">A/C Number</p>
                        <p className="text-xs font-bold text-gray-800 mt-1 tracking-widest">*******{docs.bankDetails.accountNumber.slice(-4)}</p>
                      </div>
                    </div>
                  ) : (
                    <div className="p-6 bg-amber-50/50 rounded-xl border border-amber-100/50 text-center">
                      <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-sm text-amber-500">
                        <FiAlertTriangle size={16} />
                      </div>
                      <p className="text-[9px] font-bold text-amber-600 uppercase tracking-widest leading-relaxed">Config Required</p>
                    </div>
                  )}
                </div>

                <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-gray-100 relative group transition-all hover:shadow-md md:min-h-[280px] flex flex-col justify-between">
                  <div className="flex items-center justify-between mb-5">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center shadow-sm border border-emerald-100/50">
                        <FiUsers size={18} />
                      </div>
                      <div>
                        <h3 className="text-xs font-bold text-gray-800 uppercase tracking-widest">Emergency</h3>
                        <p className="text-[8px] font-bold text-gray-400 uppercase tracking-[0.2em] mt-0.5">Primary Liaison</p>
                      </div>
                    </div>
                    <button onClick={() => setIsEmergencyModalOpen(true)} className="w-8 h-8 rounded-lg bg-gray-50 hover:bg-emerald-600 hover:text-white text-gray-400 flex items-center justify-center transition-all shadow-sm border border-gray-100">
                      <FiEdit size={12}/>
                    </button>
                  </div>
                  
                  {docs.emergencyContact1?.phone ? (
                    <div className="space-y-3">
                      <div className="p-4 bg-gray-50/50 rounded-xl border border-gray-100/50">
                        <p className="text-[9px] font-bold text-gray-400 uppercase tracking-widest">Contact Person</p>
                        <p className="text-xs font-bold text-gray-800 mt-1 uppercase tracking-tight">{docs.emergencyContact1.name}</p>
                      </div>
                      <div className="p-4 bg-gray-50/50 rounded-xl border border-gray-100/50 flex items-center gap-3 font-mono">
                        <div className="w-7 h-7 bg-white rounded-lg flex items-center justify-center text-emerald-500 shadow-sm border border-emerald-50">
                          <FiPhone size={10}/>
                        </div>
                        <p className="text-xs font-bold text-gray-800 tracking-widest">{docs.emergencyContact1.phone}</p>
                      </div>
                    </div>
                  ) : (
                    <div className="p-6 bg-amber-50/50 rounded-xl border border-amber-100/50 text-center">
                      <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-sm text-amber-500">
                        <FiAlertTriangle size={16} />
                      </div>
                      <p className="text-[9px] font-bold text-amber-600 uppercase tracking-widest leading-relaxed">Config Required</p>
                    </div>
                  )}
                </div>
              </div>

              {/* Identity Documents Table */}
              <div className="lg:col-span-3">
                <div className="bg-white shadow-lg border border-gray-100 rounded-2xl md:rounded-[2.5rem] overflow-hidden">
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between p-6 md:p-8 border-b border-gray-100 bg-gray-50/30 gap-4">
                    <div className="flex items-center gap-4">
                      <div className="w-10 h-10 md:w-12 md:h-12 rounded-2xl bg-indigo-50 text-indigo-600 flex items-center justify-center shadow-sm border border-indigo-100/50">
                        <FiCreditCard size={20} className="md:w-6 md:h-6" />
                      </div>
                      <div>
                        <h2 className="text-xs md:text-sm font-bold text-gray-800 uppercase tracking-widest">Identity Documents</h2>
                        <p className="text-[9px] md:text-[10px] font-bold text-gray-400 uppercase tracking-[0.2em] mt-1">Verification & Security Protocol</p>
                      </div>
                    </div>
                    <div className="flex items-center self-start sm:self-center gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-white border border-indigo-100 rounded-xl">
                      <div className="w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-indigo-500 animate-pulse"></div>
                      <span className="text-[8px] md:text-[9px] font-bold text-indigo-600 uppercase tracking-widest">Secure Storage Active</span>
                    </div>
                  </div>

                  <div className="overflow-x-auto custom-scrollbar">
                    <table className="min-w-[800px] w-full text-center">
                      <thead className="text-[10px] text-gray-700 uppercase tracking-[0.2em] font-black border-b border-gray-200">
                        <tr>
                          <th className="py-4 md:py-5 px-4 md:px-8 text-left">Document Signature</th>
                          <th className="py-4 md:py-5 px-4 md:px-6 text-center">Verification Status</th>
                          <th className="py-4 md:py-5 px-4 md:px-6 text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-50">
                        {filteredCategories.map((doc, idx) => {
                          const docData = docs[doc.type];
                          const isUploaded = !!docData?.url;
                          return (
                            <tr key={idx} className="hover:bg-gray-50/50 transition-colors group">
                              <td className="py-5 px-8 text-left">
                                <div className="flex items-center gap-3 md:gap-4">
                                  <div className={`w-8 h-8 md:w-10 md:h-10 rounded-xl flex items-center justify-center transition-all border shrink-0 ${isUploaded ? "bg-emerald-50 text-emerald-500 border-emerald-100 shadow-sm" : "bg-gray-50 text-gray-300 border-gray-100"}`}>
                                    <doc.icon size={16} className="md:w-[18px] md:h-[18px]" />
                                  </div>
                                  <div className="min-w-0">
                                    <h4 className="text-[11px] md:text-xs font-bold text-gray-900 uppercase tracking-widest truncate">{doc.title}</h4>
                                    <p className="text-[8px] md:text-[9px] font-bold text-gray-400 uppercase tracking-widest mt-0.5 truncate">{doc.desc}</p>
                                  </div>
                                </div>
                              </td>
                              <td className="py-5 px-6">
                                {isUploaded ? (
                                  <div className="flex flex-col items-center gap-1">
                                    <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-emerald-50 text-emerald-600 text-[10px] font-bold uppercase tracking-widest border border-emerald-100 shadow-sm">
                                      <FiCheckCircle size={11} /> VERIFIED
                                    </span>
                                    {docData.uploadedAt && <span className="text-[8px] font-bold text-gray-400 uppercase tracking-widest">{new Date(docData.uploadedAt).toLocaleDateString("en-IN", { day: 'numeric', month: 'short' })}</span>}
                                  </div>
                                ) : (
                                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-amber-50 text-amber-500 text-[10px] font-bold uppercase tracking-widest border border-amber-100 shadow-sm">
                                    <FiAlertTriangle size={11} /> MISSING
                                  </span>
                                )}
                              </td>
                              <td className="py-4 md:py-5 px-4 md:px-6 text-center">
                                <div className="flex justify-center gap-2 md:gap-4">
                                  {isUploaded ? (
                                    <>
                                      <a href={formatDocumentUrl(docData.url)} target="_blank" rel="noreferrer" className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-xl bg-indigo-50 text-indigo-700 hover:bg-indigo-600 hover:text-white border border-indigo-100 transition-all transform active:scale-90 shadow-sm" title="View Document">
                                        <FiEye size={14} className="md:w-4 md:h-4" />
                                      </a>
                                      <label className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-xl bg-gray-50 text-gray-400 hover:bg-blue-600 hover:text-white border border-gray-100 transition-all cursor-pointer active:scale-90 shadow-sm" title="Edit / Replace Document">
                                        {uploading[doc.type] ? <FiRefreshCw size={12} className="animate-spin text-indigo-500" /> : <FiEdit size={12} />}
                                        <input type="file" className="hidden" onChange={(e) => handleFileUpload(e, doc.type)} accept=".pdf,.png,.jpg,.jpeg" />
                                      </label>
                                    </>
                                  ) : (
                                    <label className="flex items-center gap-2 px-3 md:px-4 py-2 md:py-2.5 bg-gray-900 text-white rounded-xl text-[8px] md:text-[10px] font-bold uppercase tracking-widest transition-all hover:bg-black active:scale-95 shadow-lg border border-black cursor-pointer whitespace-nowrap" title="Upload Document">
                                      {uploading[doc.type] ? <FiRefreshCw size={11} className="animate-spin text-gray-400" /> : <FiUpload size={11} className="text-gray-400" />}
                                      <span>UPLOAD</span>
                                      <input type="file" className="hidden" onChange={(e) => handleFileUpload(e, doc.type)} accept=".pdf,.png,.jpg,.jpeg" />
                                    </label>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  {filteredCategories.length === 0 && (
                    <div className="p-20 text-center">
                      <div className="w-20 h-20 bg-gray-50 rounded-[2rem] flex items-center justify-center text-gray-200 mx-auto mb-6 border border-gray-100 shadow-inner">
                        <FiInbox size={35} />
                      </div>
                      <h3 className="text-base font-bold text-gray-700 uppercase tracking-widest">No Documents Found</h3>
                      <p className="text-[10px] font-bold text-gray-400 uppercase tracking-[0.2em] mt-2">Adjust your search parameters</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 flex items-center justify-center gap-3 text-[9px] font-bold text-gray-400 uppercase tracking-[0.2em]">
          <FiShield className="text-indigo-400" /> AES-256 Encryption Active • Timely Health Secure Storage
        </div>

        {/* Banking Modal */}
        <AnimatePresence>
          {isBankModalOpen && (
            <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md">
              <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }} className="bg-white w-full max-w-md rounded-3xl md:rounded-[2.5rem] shadow-2xl p-6 md:p-10 border border-gray-100 relative max-h-[95vh] overflow-y-auto">
                <button className="absolute top-4 md:top-6 right-4 md:right-6 w-8 h-8 md:w-10 md:h-10 rounded-xl bg-gray-50 flex items-center justify-center text-gray-400 hover:text-red-500 transition-all shadow-sm border border-gray-100" onClick={() => setIsBankModalOpen(false)}>
                  <FiX size={14}/>
                </button>
                <div className="mb-6 md:mb-8 flex flex-col items-center text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 bg-blue-50 text-blue-500 rounded-2xl flex items-center justify-center mb-4 shadow-inner border border-blue-100/50">
                    <FiBriefcase size={24} className="md:w-7 md:h-7"/>
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 tracking-tight uppercase tracking-widest">Banking Profile</h3>
                  <p className="text-[9px] md:text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-2">Payroll & Financial Details</p>
                </div>

                <form onSubmit={handleSaveBankDetails} className="space-y-5">
                  <div className="space-y-2">
                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Bank Name *</label>
                    <input 
                      type="text" 
                      value={bankForm.bankName} 
                      onChange={e => handleBankInputChange('bankName', e.target.value)} 
                      maxLength={30} 
                      className={`w-full px-5 py-3.5 bg-gray-50/50 border ${bankErrors.bankName ? 'border-red-500 ring-2 ring-red-500' : 'border-gray-200'} rounded-2xl focus:bg-white focus:ring-2 focus:ring-blue-500 transition-all text-sm font-bold outline-none uppercase placeholder:text-gray-300`} 
                      placeholder="e.g. HDFC BANK" 
                      title="Only alphabets and spaces allowed"
                    />
                    {bankErrors.bankName && (
                      <p className="text-[10px] font-bold text-red-500 ml-1">{bankErrors.bankName}</p>
                    )}
                  </div>
                  <div className="space-y-2">
                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Account Number *</label>
                    <input 
                      type="text" 
                      value={bankForm.accountNumber} 
                      onChange={e => handleBankInputChange('accountNumber', e.target.value)} 
                      maxLength={18} 
                      className={`w-full px-5 py-3.5 bg-gray-50/50 border ${bankErrors.accountNumber ? 'border-red-500 ring-2 ring-red-500' : 'border-gray-200'} rounded-2xl focus:bg-white focus:ring-2 focus:ring-blue-500 transition-all text-sm font-bold outline-none tracking-widest placeholder:text-gray-300 placeholder:tracking-normal`} 
                      placeholder="ENTER ACCOUNT NUMBER" 
                      title="Only numbers allowed"
                    />
                    {bankErrors.accountNumber && (
                      <p className="text-[10px] font-bold text-red-500 ml-1">{bankErrors.accountNumber}</p>
                    )}
                  </div>
                  <div className="space-y-2">
                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">IFSC Code *</label>
                    <input 
                      type="text" 
                      value={bankForm.ifscCode} 
                      onChange={e => handleBankInputChange('ifscCode', e.target.value)} 
                      maxLength={11} 
                      className={`w-full px-5 py-3.5 bg-gray-50/50 border ${bankErrors.ifscCode ? 'border-red-500 ring-2 ring-red-500' : 'border-gray-200'} rounded-2xl focus:bg-white focus:ring-2 focus:ring-blue-500 transition-all text-sm font-bold outline-none uppercase tracking-widest placeholder:text-gray-300 placeholder:tracking-normal`} 
                      placeholder="HDFC0001234" 
                      title="Only alphabets and numbers allowed"
                    />
                    {bankErrors.ifscCode && (
                      <p className="text-[10px] font-bold text-red-500 ml-1">{bankErrors.ifscCode}</p>
                    )}
                  </div>

                  <button type="submit" disabled={isSaving} className="w-full mt-8 py-4 bg-gradient-to-r from-blue-600 to-indigo-700 text-white rounded-2xl text-[10px] font-bold uppercase tracking-[0.2em] shadow-lg shadow-blue-100 hover:scale-[1.02] transition-all active:scale-95 disabled:opacity-50">
                    {isSaving ? "Transmitting..." : "Save Bank Profile"}
                  </button>
                </form>
              </motion.div>
            </div>
          )}
        </AnimatePresence>

        {/* Emergency Modal */}
        <AnimatePresence>
          {isEmergencyModalOpen && (
            <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md">
              <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }} className="bg-white w-full max-w-md rounded-3xl md:rounded-[2.5rem] shadow-2xl p-6 md:p-10 border border-gray-100 relative max-h-[95vh] overflow-y-auto">
                <button className="absolute top-4 md:top-6 right-4 md:right-6 w-8 h-8 md:w-10 md:h-10 rounded-xl bg-gray-50 flex items-center justify-center text-gray-400 hover:text-red-500 transition-all shadow-sm border border-gray-100" onClick={() => setIsEmergencyModalOpen(false)}>
                  <FiX size={14}/>
                </button>
                <div className="mb-6 md:mb-8 flex flex-col items-center text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 bg-emerald-50 text-emerald-500 rounded-2xl flex items-center justify-center mb-4 shadow-inner border border-emerald-100/50">
                    <FiUsers size={24} className="md:w-7 md:h-7"/>
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 tracking-tight uppercase tracking-widest">Emergency Contact</h3>
                  <p className="text-[9px] md:text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-2">Primary Emergency Details</p>
                </div>

                <form onSubmit={handleSaveEmergencyContact} className="space-y-5">
                  <div className="space-y-2">
                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Contact Name *</label>
                    <input 
                      type="text" 
                      value={emergencyForm.name} 
                      onChange={e => handleEmergencyInputChange('name', e.target.value)} 
                      maxLength={30} 
                      className={`w-full px-5 py-3.5 bg-gray-50/50 border ${emergencyErrors.name ? 'border-red-500 ring-2 ring-red-500' : 'border-gray-200'} rounded-2xl focus:bg-white focus:ring-2 focus:ring-emerald-500 transition-all text-sm font-bold outline-none uppercase placeholder:text-gray-300`} 
                      placeholder="ENTER FULL NAME" 
                      title="Only alphabets and spaces allowed"
                    />
                    {emergencyErrors.name && (
                      <p className="text-[10px] font-bold text-red-500 ml-1">{emergencyErrors.name}</p>
                    )}
                  </div>
                  <div className="space-y-2">
                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Phone Number *</label>
                    <input 
                      type="tel" 
                      value={emergencyForm.phone} 
                      onChange={e => handleEmergencyInputChange('phone', e.target.value)} 
                      maxLength={10} 
                      className={`w-full px-5 py-3.5 bg-gray-50/50 border ${emergencyErrors.phone ? 'border-red-500 ring-2 ring-red-500' : 'border-gray-200'} rounded-2xl focus:bg-white focus:ring-2 focus:ring-emerald-500 transition-all text-sm font-bold outline-none tracking-widest placeholder:text-gray-300 placeholder:tracking-normal`} 
                      placeholder="E.G. 9000000000" 
                      title="10 digits starting with 6, 7, 8, or 9"
                    />
                    {emergencyErrors.phone && (
                      <p className="text-[10px] font-bold text-red-500 ml-1">{emergencyErrors.phone}</p>
                    )}
                  </div>
                  <div className="space-y-2">
                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Relationship *</label>
                    <input 
                      type="text" 
                      value={emergencyForm.relationship} 
                      onChange={e => handleEmergencyInputChange('relationship', e.target.value)} 
                      maxLength={20} 
                      className={`w-full px-5 py-3.5 bg-gray-50/50 border ${emergencyErrors.relationship ? 'border-red-500 ring-2 ring-red-500' : 'border-gray-200'} rounded-2xl focus:bg-white focus:ring-2 focus:ring-emerald-500 transition-all text-sm font-bold outline-none uppercase placeholder:text-gray-300`} 
                      placeholder="E.G. SPOUSE" 
                      title="Only alphabets and spaces allowed"
                    />
                    {emergencyErrors.relationship && (
                      <p className="text-[10px] font-bold text-red-500 ml-1">{emergencyErrors.relationship}</p>
                    )}
                  </div>

                  <button type="submit" disabled={isSaving} className="w-full mt-8 py-4 bg-gradient-to-r from-emerald-500 to-teal-600 text-white rounded-2xl text-[10px] font-bold uppercase tracking-[0.2em] shadow-lg shadow-emerald-100 hover:scale-[1.02] transition-all active:scale-95 disabled:opacity-50">
                    {isSaving ? "Transmitting..." : (docs.emergencyContact1?.phone ? "Update Emergency Contact" : "Save Emergency Contact")}
                  </button>
                </form>
              </motion.div>
            </div>
          )}
        </AnimatePresence>

        {/* Personal Details Modal */}
        <AnimatePresence>
          {isPersonalModalOpen && (
            <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md">
              <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }} className="bg-white w-full max-w-2xl rounded-3xl md:rounded-[2.5rem] shadow-2xl p-6 md:p-10 border border-gray-100 relative max-h-[90vh] overflow-y-auto custom-scrollbar">
                <button className="absolute top-4 md:top-6 right-4 md:right-6 w-8 h-8 md:w-10 md:h-10 rounded-xl bg-gray-50 flex items-center justify-center text-gray-400 hover:text-red-500 transition-all shadow-sm border border-gray-100" onClick={() => setIsPersonalModalOpen(false)}>
                  <FiX size={14}/>
                </button>
                <div className="mb-6 md:mb-8 flex flex-col items-center text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 bg-indigo-50 text-indigo-500 rounded-2xl flex items-center justify-center mb-4 shadow-inner border border-indigo-100/50">
                    <FiCreditCard size={24} className="md:w-7 md:h-7"/>
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 tracking-tight uppercase tracking-widest">Personal Details</h3>
                  <p className="text-[9px] md:text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-2">Candidate Profile</p>
                </div>

                <form onSubmit={handleSavePersonalDetails} className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-2">
                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Full Name *</label>
                    <input 
                      type="text" 
                      value={personalForm.name} 
                      onChange={e => handlePersonalInputChange('name', e.target.value)} 
                      maxLength={30} 
                      className={`w-full px-5 py-3 bg-gray-50/50 border ${personalErrors.name ? 'border-red-500 ring-2 ring-red-500' : 'border-gray-200'} rounded-2xl focus:bg-white focus:ring-2 focus:ring-indigo-500 transition-all text-sm font-bold outline-none`} 
                      placeholder="Enter full name (alphabets only)" 
                      title="Only alphabets and spaces are allowed"
                    />
                    {personalErrors.name && (
                      <p className="text-[10px] font-bold text-red-500 ml-1">{personalErrors.name}</p>
                    )}
                  </div>
                  <div className="space-y-2">
                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Phone Number *</label>
                    <input 
                      type="tel" 
                      value={personalForm.phone} 
                      onChange={e => handlePersonalInputChange('phone', e.target.value)} 
                      maxLength={10} 
                      className={`w-full px-5 py-3 bg-gray-50/50 border ${personalErrors.phone ? 'border-red-500 ring-2 ring-red-500' : 'border-gray-200'} rounded-2xl focus:bg-white focus:ring-2 focus:ring-indigo-500 transition-all text-sm font-bold outline-none`} 
                      placeholder="9000000000" 
                      title="10 digits starting with 6, 7, 8, or 9"
                    />
                    {personalErrors.phone && (
                      <p className="text-[10px] font-bold text-red-500 ml-1">{personalErrors.phone}</p>
                    )}
                  </div>
                  <div className="space-y-2">
                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Date of Birth</label>
                    <input 
                      type="date" 
                      value={personalForm.dob} 
                      onChange={e => setPersonalForm({...personalForm, dob: e.target.value})} 
                      max={formatDateForDisplay(new Date())}
                      className="w-full px-5 py-3 bg-gray-50/50 border border-gray-200 rounded-2xl focus:bg-white focus:ring-2 focus:ring-indigo-500 transition-all text-sm font-bold outline-none" 
                    />
                  </div>
                  <div className="space-y-2">
                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Gender</label>
                    <select value={personalForm.gender} onChange={e => setPersonalForm({...personalForm, gender: e.target.value})} className="w-full px-5 py-3 bg-gray-50/50 border border-gray-200 rounded-2xl focus:bg-white focus:ring-2 focus:ring-indigo-500 transition-all text-sm font-bold outline-none">
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                      <option value="Prefer not to say">Prefer not to say</option>
                    </select>
                  </div>
                  <div className="md:col-span-2 space-y-2">
                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Current Address *</label>
                    <input 
                      type="text" 
                      value={personalForm.address} 
                      onChange={e => handlePersonalInputChange('address', e.target.value)} 
                      maxLength={50} 
                      className={`w-full px-5 py-3 bg-gray-50/50 border ${personalErrors.address ? 'border-red-500 ring-2 ring-red-500' : 'border-gray-200'} rounded-2xl focus:bg-white focus:ring-2 focus:ring-indigo-500 transition-all text-sm font-bold outline-none`} 
                      placeholder="Road Number, Street Name, Landmark" 
                      title="Alphabets, numbers, spaces, and common punctuation allowed"
                    />
                    {personalErrors.address && (
                      <p className="text-[10px] font-bold text-red-500 ml-1">{personalErrors.address}</p>
                    )}
                  </div>
                  <div className="space-y-2">
                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">City *</label>
                    <input 
                      type="text" 
                      value={personalForm.city} 
                      onChange={e => handlePersonalInputChange('city', e.target.value)} 
                      maxLength={20} 
                      className={`w-full px-5 py-3 bg-gray-50/50 border ${personalErrors.city ? 'border-red-500 ring-2 ring-red-500' : 'border-gray-200'} rounded-2xl focus:bg-white focus:ring-2 focus:ring-indigo-500 transition-all text-sm font-bold outline-none`} 
                      placeholder="City" 
                      title="Only alphabets and spaces allowed"
                    />
                    {personalErrors.city && (
                      <p className="text-[10px] font-bold text-red-500 ml-1">{personalErrors.city}</p>
                    )}
                  </div>
                  <div className="space-y-2">
                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">State *</label>
                    <input 
                      type="text" 
                      value={personalForm.state} 
                      onChange={e => handlePersonalInputChange('state', e.target.value)} 
                      maxLength={20} 
                      className={`w-full px-5 py-3 bg-gray-50/50 border ${personalErrors.state ? 'border-red-500 ring-2 ring-red-500' : 'border-gray-200'} rounded-2xl focus:bg-white focus:ring-2 focus:ring-indigo-500 transition-all text-sm font-bold outline-none`} 
                      placeholder="State" 
                      title="Only alphabets and spaces allowed"
                    />
                    {personalErrors.state && (
                      <p className="text-[10px] font-bold text-red-500 ml-1">{personalErrors.state}</p>
                    )}
                  </div>
                  <div className="space-y-2">
                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Pincode *</label>
                    <input
                      type="text"
                      value={personalForm.pincode}
                      onChange={e => handlePersonalInputChange('pincode', e.target.value)}
                      maxLength={6}
                      className={`w-full px-5 py-3 bg-gray-50/50 border ${personalErrors.pincode ? 'border-red-500 ring-2 ring-red-500' : 'border-gray-200'} rounded-2xl focus:bg-white focus:ring-2 focus:ring-indigo-500 transition-all text-sm font-bold outline-none`}
                      placeholder="Pincode"
                      title="Exactly 6 digits"
                    />
                    {personalErrors.pincode && (
                      <p className="text-[10px] font-bold text-red-500 ml-1">{personalErrors.pincode}</p>
                    )}
                  </div>

                  <div className="md:col-span-2 space-y-2">
                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Desired Roles (Select Multiple)</label>
                    <div className="relative" ref={roleDropdownRef}>
                      <div
                        onClick={() => setShowRoleDropdown(!showRoleDropdown)}
                        className={`w-full min-h-[50px] px-4 py-2.5 bg-gray-50/50 border ${personalErrors.role ? 'border-red-500 ring-2 ring-red-500' : 'border-gray-200'} rounded-2xl focus-within:ring-2 focus-within:ring-indigo-500 outline-none transition-all text-sm font-bold text-gray-700 flex flex-wrap gap-2 items-center cursor-pointer`}
                      >
                        {personalForm.role.length === 0 ? (
                          <span className="text-gray-400">Select roles...</span>
                        ) : (
                          personalForm.role.map((role) => (
                            <span
                              key={role}
                              className="bg-indigo-50 text-indigo-600 px-3 py-1 rounded-lg text-xs font-bold flex items-center gap-1.5"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRoleToggle(role);
                              }}
                            >
                              {role}
                              <FiX className="hover:text-indigo-800 cursor-pointer" />
                            </span>
                          ))
                        )}
                      </div>
                      <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-gray-300">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                          <path d="m6 9 6 6 6-6" />
                        </svg>
                      </div>

                      {showRoleDropdown && (
                        <div className="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-2xl shadow-lg max-h-60 overflow-y-auto no-scrollbar p-2 space-y-1">
                          <div className="px-1 py-1 sticky top-0 bg-white border-b border-gray-100 mb-2 z-10">
                            <input
                              type="text"
                              value={roleSearch}
                              onChange={(e) => setRoleSearch(e.target.value)}
                              placeholder="Search roles..."
                              className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-xs outline-none focus:border-indigo-600 font-medium"
                              onClick={(e) => e.stopPropagation()}
                            />
                          </div>
                          {availableRoles.filter(role => role.toLowerCase().includes(roleSearch.toLowerCase())).length === 0 ? (
                            <div className="p-3 text-xs text-gray-400 text-center font-bold uppercase">No matching roles</div>
                          ) : (
                            availableRoles.filter(role => role.toLowerCase().includes(roleSearch.toLowerCase())).map((role) => {
                              const isSelected = personalForm.role.includes(role);
                              return (
                                <div
                                  key={role}
                                  onClick={() => handleRoleToggle(role)}
                                  className={`px-3 py-2 text-xs font-bold rounded-lg cursor-pointer flex items-center justify-between transition-colors ${
                                    isSelected
                                      ? "bg-indigo-50 text-indigo-600"
                                      : "text-gray-600 hover:bg-gray-50"
                                  }`}
                                >
                                  <span>{role}</span>
                                  {isSelected && <FiCheckCircle className="text-indigo-600" />}
                                </div>
                              );
                            })
                          )}
                        </div>
                      )}
                    </div>
                    {personalErrors.role && (
                      <p className="text-[10px] font-bold text-red-500 ml-1">{personalErrors.role}</p>
                    )}
                  </div>

                  <div className="md:col-span-2 pt-4">
                    <button type="submit" disabled={isSaving} className="w-full py-4 bg-gradient-to-r from-indigo-600 to-purple-700 text-white rounded-2xl text-[10px] font-bold uppercase tracking-[0.2em] shadow-lg shadow-indigo-100 hover:scale-[1.01] transition-all active:scale-95 disabled:opacity-50">
                      {isSaving ? "Synchronizing..." : "Save Profile Details"}
                    </button>
                  </div>
                </form>
              </motion.div>
            </div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default CandidatePersonalDocuments;